var items = {
  "block.minecraft.acacia_button": "Knob o' acacia",
  "block.minecraft.acacia_door": "Door o' acacia",
  "block.minecraft.acacia_fence": "Picket o' acacia",
  "block.minecraft.acacia_fence_gate": "Picket gate o' acacia",
  "block.minecraft.acacia_hanging_sign": "Danglin' seal o' acacia",
  "block.minecraft.acacia_leaves": "Leaves o' acacia",
  "block.minecraft.acacia_log": "Log o' acacia",
  "block.minecraft.acacia_planks": "Planks o' acacia",
  "block.minecraft.acacia_pressure_plate": "Booby trap o' acacia",
  "block.minecraft.acacia_sapling": "Acacia meager shrub",
  "block.minecraft.acacia_shelf": "Rack o' acacia",
  "block.minecraft.acacia_sign": "Seal o' acacia",
  "block.minecraft.acacia_slab": "Slab o' acacia",
  "block.minecraft.acacia_stairs": "Stairs o' acacia",
  "block.minecraft.acacia_trapdoor": "Hatch o' acacia",
  "block.minecraft.acacia_wall_hanging_sign": "Danglin' wall seal o' acacia",
  "block.minecraft.acacia_wall_sign": "Wall seal o' acacia",
  "block.minecraft.acacia_wood": "Acacia timber",
  "block.minecraft.activator_rail": "Fuse track",
  "block.minecraft.air": "Sail blower",
  "block.minecraft.allium": "Pink fluff",
  "block.minecraft.amethyst_block": "Block o’ purple gems",
  "block.minecraft.amethyst_cluster": "Clump o' gems",
  "block.minecraft.ancient_debris": "Treasure o' Davy Jones",
  "block.minecraft.andesite": "Gray pebbles",
  "block.minecraft.andesite_slab": "Slab o' gray pebbles",
  "block.minecraft.andesite_stairs": "Stairs o' gray pebbles",
  "block.minecraft.andesite_wall": "Wall o' gray pebbles",
  "block.minecraft.anvil": "Slab o' fixin'",
  "block.minecraft.attached_melon_stem": "Tied twig o' melon",
  "block.minecraft.attached_pumpkin_stem": "Tied twig o' gourd squash",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Leaves o' azalea",
  "block.minecraft.azure_bluet": "Blue flower",
  "block.minecraft.bamboo": "Bambarrr",
  "block.minecraft.bamboo_block": "Block o' bambarrr",
  "block.minecraft.bamboo_button": "Knob o' bambarrr",
  "block.minecraft.bamboo_door": "Door o' bambarrr",
  "block.minecraft.bamboo_fence": "Picket o' bambarrr",
  "block.minecraft.bamboo_fence_gate": "Picket gate o' bambarrr",
  "block.minecraft.bamboo_hanging_sign": "Danglin' seal o' bambarrr",
  "block.minecraft.bamboo_mosaic": "Pretty bambarrr",
  "block.minecraft.bamboo_mosaic_slab": "Slab o' pretty bambarrr",
  "block.minecraft.bamboo_mosaic_stairs": "Stairs o' pretty bambarrr",
  "block.minecraft.bamboo_planks": "Planks o' bambarrr",
  "block.minecraft.bamboo_pressure_plate": "Booby trap o' bambarrr",
  "block.minecraft.bamboo_sapling": "Bambarrr Baby",
  "block.minecraft.bamboo_shelf": "Rack o' bambarrr",
  "block.minecraft.bamboo_sign": "Seal o' bambarrr",
  "block.minecraft.bamboo_slab": "Slab o' bambarrr",
  "block.minecraft.bamboo_stairs": "Stairs o' bambarrr",
  "block.minecraft.bamboo_trapdoor": "Hatch o' bambarrr",
  "block.minecraft.bamboo_wall_hanging_sign": "Danglin' wall seal o' bambarrr",
  "block.minecraft.bamboo_wall_sign": "Wall seal o' bambarrr",
  "block.minecraft.banner.base.black": "Fully black field",
  "block.minecraft.banner.base.blue": "Fully blue field",
  "block.minecraft.banner.base.brown": "Fully brown field",
  "block.minecraft.banner.base.cyan": "Fully ocean blue field",
  "block.minecraft.banner.base.gray": "Fully gray field",
  "block.minecraft.banner.base.green": "Fully green field",
  "block.minecraft.banner.base.light_blue": "Fully light blue field",
  "block.minecraft.banner.base.light_gray": "Fully light gray field",
  "block.minecraft.banner.base.lime": "Fully light green field",
  "block.minecraft.banner.base.magenta": "Fully light purple field",
  "block.minecraft.banner.base.orange": "Fully orange field",
  "block.minecraft.banner.base.pink": "Fully pink field",
  "block.minecraft.banner.base.purple": "Fully purple field",
  "block.minecraft.banner.base.red": "Fully scarlet field",
  "block.minecraft.banner.base.white": "Fully white field",
  "block.minecraft.banner.base.yellow": "Fully yellow field",
  "block.minecraft.banner.border.black": "Black bordure",
  "block.minecraft.banner.border.blue": "Blue bordure",
  "block.minecraft.banner.border.brown": "Brown bordure",
  "block.minecraft.banner.border.cyan": "Ocean blue bordure",
  "block.minecraft.banner.border.gray": "Gray bordure",
  "block.minecraft.banner.border.green": "Green bordure",
  "block.minecraft.banner.border.light_blue": "Light blue bordure",
  "block.minecraft.banner.border.light_gray": "Light gray bordure",
  "block.minecraft.banner.border.lime": "Light green bordure",
  "block.minecraft.banner.border.magenta": "Light purple bordure",
  "block.minecraft.banner.border.orange": "Orange bordure",
  "block.minecraft.banner.border.pink": "Pink bordure",
  "block.minecraft.banner.border.purple": "Purple bordure",
  "block.minecraft.banner.border.red": "Scarlet bordure",
  "block.minecraft.banner.border.white": "White bordure",
  "block.minecraft.banner.border.yellow": "Yellow bordure",
  "block.minecraft.banner.bricks.black": "Black field masoned",
  "block.minecraft.banner.bricks.blue": "Blue field masoned",
  "block.minecraft.banner.bricks.brown": "Brown field masoned",
  "block.minecraft.banner.bricks.cyan": "Ocean blue field masoned",
  "block.minecraft.banner.bricks.gray": "Gray field masoned",
  "block.minecraft.banner.bricks.green": "Green field masoned",
  "block.minecraft.banner.bricks.light_blue": "Light blue field masoned",
  "block.minecraft.banner.bricks.light_gray": "Light gray field masoned",
  "block.minecraft.banner.bricks.lime": "Light green field masoned",
  "block.minecraft.banner.bricks.magenta": "Light purple field masoned",
  "block.minecraft.banner.bricks.orange": "Orange field masoned",
  "block.minecraft.banner.bricks.pink": "Pink field masoned",
  "block.minecraft.banner.bricks.purple": "Purple field masoned",
  "block.minecraft.banner.bricks.red": "Scarlet field masoned",
  "block.minecraft.banner.bricks.white": "White field masoned",
  "block.minecraft.banner.bricks.yellow": "Yellow field masoned",
  "block.minecraft.banner.circle.black": "Black roundel",
  "block.minecraft.banner.circle.blue": "Blue roundel",
  "block.minecraft.banner.circle.brown": "Brown roundel",
  "block.minecraft.banner.circle.cyan": "Ocean blue roundel",
  "block.minecraft.banner.circle.gray": "Gray roundel",
  "block.minecraft.banner.circle.green": "Green roundel",
  "block.minecraft.banner.circle.light_blue": "Light blue roundel",
  "block.minecraft.banner.circle.light_gray": "Light gray roundel",
  "block.minecraft.banner.circle.lime": "Light green roundel",
  "block.minecraft.banner.circle.magenta": "Light purple roundel",
  "block.minecraft.banner.circle.orange": "Orange roundel",
  "block.minecraft.banner.circle.pink": "Pink roundel",
  "block.minecraft.banner.circle.purple": "Purple roundel",
  "block.minecraft.banner.circle.red": "Scarlet roundel",
  "block.minecraft.banner.circle.white": "White roundel",
  "block.minecraft.banner.circle.yellow": "Yellow roundel",
  "block.minecraft.banner.creeper.black": "Black creeper charge",
  "block.minecraft.banner.creeper.blue": "Blue creeper charge",
  "block.minecraft.banner.creeper.brown": "Brown creeper charge",
  "block.minecraft.banner.creeper.cyan": "Ocean blue creeper charge",
  "block.minecraft.banner.creeper.gray": "Gray creeper charge",
  "block.minecraft.banner.creeper.green": "Green creeper charge",
  "block.minecraft.banner.creeper.light_blue": "Light blue creeper charge",
  "block.minecraft.banner.creeper.light_gray": "Light gray creeper charge",
  "block.minecraft.banner.creeper.lime": "Light green creeper charge",
  "block.minecraft.banner.creeper.magenta": "Light purple creeper charge",
  "block.minecraft.banner.creeper.orange": "Orange creeper charge",
  "block.minecraft.banner.creeper.pink": "Pink creeper charge",
  "block.minecraft.banner.creeper.purple": "Purple creeper charge",
  "block.minecraft.banner.creeper.red": "Scarlet creeper charge",
  "block.minecraft.banner.creeper.white": "White creeper charge",
  "block.minecraft.banner.creeper.yellow": "Yellow creeper charge",
  "block.minecraft.banner.cross.black": "Black saltire",
  "block.minecraft.banner.cross.blue": "Blue saltire",
  "block.minecraft.banner.cross.brown": "Brown saltire",
  "block.minecraft.banner.cross.cyan": "Ocean blue saltire",
  "block.minecraft.banner.cross.gray": "Gray saltire",
  "block.minecraft.banner.cross.green": "Green saltire",
  "block.minecraft.banner.cross.light_blue": "Light blue saltire",
  "block.minecraft.banner.cross.light_gray": "Light gray saltire",
  "block.minecraft.banner.cross.lime": "Light green saltire",
  "block.minecraft.banner.cross.magenta": "Light purple saltire",
  "block.minecraft.banner.cross.orange": "Orange saltire",
  "block.minecraft.banner.cross.pink": "Pink saltire",
  "block.minecraft.banner.cross.purple": "Purple saltire",
  "block.minecraft.banner.cross.red": "Scarlet saltire",
  "block.minecraft.banner.cross.white": "White saltire",
  "block.minecraft.banner.cross.yellow": "Yellow saltire",
  "block.minecraft.banner.curly_border.black": "Black bordure indented",
  "block.minecraft.banner.curly_border.blue": "Blue bordure indented",
  "block.minecraft.banner.curly_border.brown": "Brown bordure indented",
  "block.minecraft.banner.curly_border.cyan": "Ocean blue bordure indented",
  "block.minecraft.banner.curly_border.gray": "Gray bordure indented",
  "block.minecraft.banner.curly_border.green": "Green bordure indented",
  "block.minecraft.banner.curly_border.light_blue": "Light blue bordure indented",
  "block.minecraft.banner.curly_border.light_gray": "Light gray bordure indented",
  "block.minecraft.banner.curly_border.lime": "Light green bordure indented",
  "block.minecraft.banner.curly_border.magenta": "Light purple bordure indented",
  "block.minecraft.banner.curly_border.orange": "Orange bordure indented",
  "block.minecraft.banner.curly_border.pink": "Pink bordure indented",
  "block.minecraft.banner.curly_border.purple": "Purple bordure indented",
  "block.minecraft.banner.curly_border.red": "Scarlet bordure indented",
  "block.minecraft.banner.curly_border.white": "White bordure indented",
  "block.minecraft.banner.curly_border.yellow": "Yellow bordure indented",
  "block.minecraft.banner.diagonal_left.black": "Black per bend sinister",
  "block.minecraft.banner.diagonal_left.blue": "Blue per bend sinister",
  "block.minecraft.banner.diagonal_left.brown": "Brown per bend sinister",
  "block.minecraft.banner.diagonal_left.cyan": "Ocean blue per bend sinister",
  "block.minecraft.banner.diagonal_left.gray": "Gray per bend sinister",
  "block.minecraft.banner.diagonal_left.green": "Green per bend sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Light blue per bend sinister",
  "block.minecraft.banner.diagonal_left.light_gray": "Light gray per bend sinister",
  "block.minecraft.banner.diagonal_left.lime": "Light green per bend sinister",
  "block.minecraft.banner.diagonal_left.magenta": "Light purple per bend sinister",
  "block.minecraft.banner.diagonal_left.orange": "Orange per bend sinister",
  "block.minecraft.banner.diagonal_left.pink": "Pink per bend sinister",
  "block.minecraft.banner.diagonal_left.purple": "Purple per bend sinister",
  "block.minecraft.banner.diagonal_left.red": "Scarlet per bend sinister",
  "block.minecraft.banner.diagonal_left.white": "White per bend sinister",
  "block.minecraft.banner.diagonal_left.yellow": "Yellow per bend sinister",
  "block.minecraft.banner.diagonal_right.black": "Black per bend",
  "block.minecraft.banner.diagonal_right.blue": "Blue per bend",
  "block.minecraft.banner.diagonal_right.brown": "Brown per bend",
  "block.minecraft.banner.diagonal_right.cyan": "Ocean blue per bend",
  "block.minecraft.banner.diagonal_right.gray": "Gray per bend",
  "block.minecraft.banner.diagonal_right.green": "Green per bend",
  "block.minecraft.banner.diagonal_right.light_blue": "Light blue per bend",
  "block.minecraft.banner.diagonal_right.light_gray": "Light gray per bend",
  "block.minecraft.banner.diagonal_right.lime": "Light green per bend",
  "block.minecraft.banner.diagonal_right.magenta": "Light purple per bend",
  "block.minecraft.banner.diagonal_right.orange": "Orange per bend",
  "block.minecraft.banner.diagonal_right.pink": "Pink per bend",
  "block.minecraft.banner.diagonal_right.purple": "Purple per bend",
  "block.minecraft.banner.diagonal_right.red": "Scarlet per bend",
  "block.minecraft.banner.diagonal_right.white": "White per bend",
  "block.minecraft.banner.diagonal_right.yellow": "Yellow per bend",
  "block.minecraft.banner.diagonal_up_left.black": "Black per bend inverted",
  "block.minecraft.banner.diagonal_up_left.blue": "Blue per bend inverted",
  "block.minecraft.banner.diagonal_up_left.brown": "Brown per bend inverted",
  "block.minecraft.banner.diagonal_up_left.cyan": "Ocean blue per bend inverted",
  "block.minecraft.banner.diagonal_up_left.gray": "Gray per bend inverted",
  "block.minecraft.banner.diagonal_up_left.green": "Green per bend inverted",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Light blue per bend inverted",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Light gray per bend inverted",
  "block.minecraft.banner.diagonal_up_left.lime": "Light green per bend inverted",
  "block.minecraft.banner.diagonal_up_left.magenta": "Light purple per bend inverted",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange per bend inverted",
  "block.minecraft.banner.diagonal_up_left.pink": "Pink per bend inverted",
  "block.minecraft.banner.diagonal_up_left.purple": "Purple per bend inverted",
  "block.minecraft.banner.diagonal_up_left.red": "Scarlet per bend inverted",
  "block.minecraft.banner.diagonal_up_left.white": "White per bend inverted",
  "block.minecraft.banner.diagonal_up_left.yellow": "Yellow per bend inverted",
  "block.minecraft.banner.diagonal_up_right.black": "Black per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.blue": "Blue per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.brown": "Brown per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.cyan": "Ocean blue per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.gray": "Gray per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.green": "Green per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Light blue per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Light gray per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.lime": "Light green per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.magenta": "Light purple per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.pink": "Pink per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.purple": "Purple per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.red": "Scarlet per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.white": "White per bend sinister inverted",
  "block.minecraft.banner.diagonal_up_right.yellow": "Yellow per bend sinister inverted",
  "block.minecraft.banner.flow.black": "Black flow",
  "block.minecraft.banner.flow.blue": "Blue flow",
  "block.minecraft.banner.flow.brown": "Brown flow",
  "block.minecraft.banner.flow.cyan": "Ocean blue flow",
  "block.minecraft.banner.flow.gray": "Gray flow",
  "block.minecraft.banner.flow.green": "Green flow",
  "block.minecraft.banner.flow.light_blue": "Light blue flow",
  "block.minecraft.banner.flow.light_gray": "Light gray flow",
  "block.minecraft.banner.flow.lime": "Light green flow",
  "block.minecraft.banner.flow.magenta": "Light purple flow",
  "block.minecraft.banner.flow.orange": "Orange flow",
  "block.minecraft.banner.flow.pink": "Pink flow",
  "block.minecraft.banner.flow.purple": "Purple flow",
  "block.minecraft.banner.flow.red": "Scarlet flow",
  "block.minecraft.banner.flow.white": "White flow",
  "block.minecraft.banner.flow.yellow": "Yellow flow",
  "block.minecraft.banner.flower.black": "Black flower charge",
  "block.minecraft.banner.flower.blue": "Blue flower charge",
  "block.minecraft.banner.flower.brown": "Brown flower charge",
  "block.minecraft.banner.flower.cyan": "Ocean blue flower charge",
  "block.minecraft.banner.flower.gray": "Gray flower charge",
  "block.minecraft.banner.flower.green": "Green flower charge",
  "block.minecraft.banner.flower.light_blue": "Light blue flower charge",
  "block.minecraft.banner.flower.light_gray": "Light gray flower charge",
  "block.minecraft.banner.flower.lime": "Light green flower charge",
  "block.minecraft.banner.flower.magenta": "Light purple flower charge",
  "block.minecraft.banner.flower.orange": "Orange flower charge",
  "block.minecraft.banner.flower.pink": "Pink flower charge",
  "block.minecraft.banner.flower.purple": "Purple flower charge",
  "block.minecraft.banner.flower.red": "Scarlet flower charge",
  "block.minecraft.banner.flower.white": "White flower charge",
  "block.minecraft.banner.flower.yellow": "Yellow flower charge",
  "block.minecraft.banner.globe.black": "Black globe",
  "block.minecraft.banner.globe.blue": "Blue globe",
  "block.minecraft.banner.globe.brown": "Brown globe",
  "block.minecraft.banner.globe.cyan": "Ocean blue globe",
  "block.minecraft.banner.globe.gray": "Gray globe",
  "block.minecraft.banner.globe.green": "Green globe",
  "block.minecraft.banner.globe.light_blue": "Light blue globe",
  "block.minecraft.banner.globe.light_gray": "Light gray globe",
  "block.minecraft.banner.globe.lime": "Light green globe",
  "block.minecraft.banner.globe.magenta": "Light purple globe",
  "block.minecraft.banner.globe.orange": "Orange globe",
  "block.minecraft.banner.globe.pink": "Pink globe",
  "block.minecraft.banner.globe.purple": "Purple globe",
  "block.minecraft.banner.globe.red": "Scarlet globe",
  "block.minecraft.banner.globe.white": "White globe",
  "block.minecraft.banner.globe.yellow": "Yellow globe",
  "block.minecraft.banner.gradient.black": "Black gradient",
  "block.minecraft.banner.gradient.blue": "Blue gradient",
  "block.minecraft.banner.gradient.brown": "Brown gradient",
  "block.minecraft.banner.gradient.cyan": "Ocean blue gradient",
  "block.minecraft.banner.gradient.gray": "Gray gradient",
  "block.minecraft.banner.gradient.green": "Green gradient",
  "block.minecraft.banner.gradient.light_blue": "Light blue gradient",
  "block.minecraft.banner.gradient.light_gray": "Light gray gradient",
  "block.minecraft.banner.gradient.lime": "Light green gradient",
  "block.minecraft.banner.gradient.magenta": "Light purple gradient",
  "block.minecraft.banner.gradient.orange": "Orange gradient",
  "block.minecraft.banner.gradient.pink": "Pink gradient",
  "block.minecraft.banner.gradient.purple": "Purple gradient",
  "block.minecraft.banner.gradient.red": "Scarlet gradient",
  "block.minecraft.banner.gradient.white": "White gradient",
  "block.minecraft.banner.gradient.yellow": "Yellow gradient",
  "block.minecraft.banner.gradient_up.black": "Black base bradient",
  "block.minecraft.banner.gradient_up.blue": "Blue base gradient",
  "block.minecraft.banner.gradient_up.brown": "Brown base gradient",
  "block.minecraft.banner.gradient_up.cyan": "Ocean blue base gradient",
  "block.minecraft.banner.gradient_up.gray": "Gray base gradient",
  "block.minecraft.banner.gradient_up.green": "Green base gradient",
  "block.minecraft.banner.gradient_up.light_blue": "Light blue base gradient",
  "block.minecraft.banner.gradient_up.light_gray": "Light gray base gradient",
  "block.minecraft.banner.gradient_up.lime": "Light green base gradient",
  "block.minecraft.banner.gradient_up.magenta": "Light purple base gradient",
  "block.minecraft.banner.gradient_up.orange": "Orange base gradient",
  "block.minecraft.banner.gradient_up.pink": "Pink base gradient",
  "block.minecraft.banner.gradient_up.purple": "Purple base gradient",
  "block.minecraft.banner.gradient_up.red": "Scarlet base gradient",
  "block.minecraft.banner.gradient_up.white": "White base gradient",
  "block.minecraft.banner.gradient_up.yellow": "Yellow base gradient",
  "block.minecraft.banner.guster.black": "Black guster",
  "block.minecraft.banner.guster.blue": "Blue guster",
  "block.minecraft.banner.guster.brown": "Brown guster",
  "block.minecraft.banner.guster.cyan": "Ocean blue guster",
  "block.minecraft.banner.guster.gray": "Gray guster",
  "block.minecraft.banner.guster.green": "Green guster",
  "block.minecraft.banner.guster.light_blue": "Light blue guster",
  "block.minecraft.banner.guster.light_gray": "Light gray guster",
  "block.minecraft.banner.guster.lime": "Light green guster",
  "block.minecraft.banner.guster.magenta": "Light purple guster",
  "block.minecraft.banner.guster.orange": "Orange guster",
  "block.minecraft.banner.guster.pink": "Pink guster",
  "block.minecraft.banner.guster.purple": "Purple guster",
  "block.minecraft.banner.guster.red": "Scarlet guster",
  "block.minecraft.banner.guster.white": "White guster",
  "block.minecraft.banner.guster.yellow": "Yellow guster",
  "block.minecraft.banner.half_horizontal.black": "Black per fess",
  "block.minecraft.banner.half_horizontal.blue": "Blue per fess",
  "block.minecraft.banner.half_horizontal.brown": "Brown per fess",
  "block.minecraft.banner.half_horizontal.cyan": "Ocean blue per fess",
  "block.minecraft.banner.half_horizontal.gray": "Gray per fess",
  "block.minecraft.banner.half_horizontal.green": "Green per fess",
  "block.minecraft.banner.half_horizontal.light_blue": "Light blue per fess",
  "block.minecraft.banner.half_horizontal.light_gray": "Light gray per fess",
  "block.minecraft.banner.half_horizontal.lime": "Light green per fess",
  "block.minecraft.banner.half_horizontal.magenta": "Light purple per fess",
  "block.minecraft.banner.half_horizontal.orange": "Orange per fess",
  "block.minecraft.banner.half_horizontal.pink": "Pink per fess",
  "block.minecraft.banner.half_horizontal.purple": "Purple per fess",
  "block.minecraft.banner.half_horizontal.red": "Scarlet per fess",
  "block.minecraft.banner.half_horizontal.white": "White per fess",
  "block.minecraft.banner.half_horizontal.yellow": "Yellow per fess",
  "block.minecraft.banner.half_horizontal_bottom.black": "Black per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blue per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brown per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Ocean blue per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Gray per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.green": "Green per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Light blue per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Light gray per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Light green per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Light purple per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Orange per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Pink per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Purple per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.red": "Scarlet per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.white": "White per fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Yellow per fess inverted",
  "block.minecraft.banner.half_vertical.black": "Black per pale",
  "block.minecraft.banner.half_vertical.blue": "Blue per pale",
  "block.minecraft.banner.half_vertical.brown": "Brown per pale",
  "block.minecraft.banner.half_vertical.cyan": "Ocean blue per pale",
  "block.minecraft.banner.half_vertical.gray": "Gray per pale",
  "block.minecraft.banner.half_vertical.green": "Green per pale",
  "block.minecraft.banner.half_vertical.light_blue": "Light blue per pale",
  "block.minecraft.banner.half_vertical.light_gray": "Light gray per pale",
  "block.minecraft.banner.half_vertical.lime": "Light green per pale",
  "block.minecraft.banner.half_vertical.magenta": "Light purple per pale",
  "block.minecraft.banner.half_vertical.orange": "Orange per pale",
  "block.minecraft.banner.half_vertical.pink": "Pink per pale",
  "block.minecraft.banner.half_vertical.purple": "Purple per pale",
  "block.minecraft.banner.half_vertical.red": "Scarlet per pale",
  "block.minecraft.banner.half_vertical.white": "White per pale",
  "block.minecraft.banner.half_vertical.yellow": "Yellow per pale",
  "block.minecraft.banner.half_vertical_right.black": "Black per pale inverted",
  "block.minecraft.banner.half_vertical_right.blue": "Blue per pale inverted",
  "block.minecraft.banner.half_vertical_right.brown": "Brown per pale inverted",
  "block.minecraft.banner.half_vertical_right.cyan": "Ocean blue per pale inverted",
  "block.minecraft.banner.half_vertical_right.gray": "Gray per pale inverted",
  "block.minecraft.banner.half_vertical_right.green": "Green per pale inverted",
  "block.minecraft.banner.half_vertical_right.light_blue": "Light blue per pale inverted",
  "block.minecraft.banner.half_vertical_right.light_gray": "Light gray per pale inverted",
  "block.minecraft.banner.half_vertical_right.lime": "Light green per pale inverted",
  "block.minecraft.banner.half_vertical_right.magenta": "Light purple per pale inverted",
  "block.minecraft.banner.half_vertical_right.orange": "Orange per pale inverted",
  "block.minecraft.banner.half_vertical_right.pink": "Pink per pale inverted",
  "block.minecraft.banner.half_vertical_right.purple": "Purple per pale inverted",
  "block.minecraft.banner.half_vertical_right.red": "Scarlet per pale inverted",
  "block.minecraft.banner.half_vertical_right.white": "White per pale inverted",
  "block.minecraft.banner.half_vertical_right.yellow": "Yellow per pale inverted",
  "block.minecraft.banner.mojang.black": "Black thing",
  "block.minecraft.banner.mojang.blue": "Blue thing",
  "block.minecraft.banner.mojang.brown": "Brown thing",
  "block.minecraft.banner.mojang.cyan": "Ocean blue thing",
  "block.minecraft.banner.mojang.gray": "Gray thing",
  "block.minecraft.banner.mojang.green": "Green thing",
  "block.minecraft.banner.mojang.light_blue": "Light blue thing",
  "block.minecraft.banner.mojang.light_gray": "Light gray thing",
  "block.minecraft.banner.mojang.lime": "Light green thing",
  "block.minecraft.banner.mojang.magenta": "Light purple thing",
  "block.minecraft.banner.mojang.orange": "Orange thing",
  "block.minecraft.banner.mojang.pink": "Pink thing",
  "block.minecraft.banner.mojang.purple": "Purple thing",
  "block.minecraft.banner.mojang.red": "Scarlet thing",
  "block.minecraft.banner.mojang.white": "White thing",
  "block.minecraft.banner.mojang.yellow": "Yellow thing",
  "block.minecraft.banner.piglin.black": "Black snout",
  "block.minecraft.banner.piglin.blue": "Blue snout",
  "block.minecraft.banner.piglin.brown": "Brown snout",
  "block.minecraft.banner.piglin.cyan": "Ocean blue snout",
  "block.minecraft.banner.piglin.gray": "Gray snout",
  "block.minecraft.banner.piglin.green": "Green snout",
  "block.minecraft.banner.piglin.light_blue": "Light blue snout",
  "block.minecraft.banner.piglin.light_gray": "Light gray snout",
  "block.minecraft.banner.piglin.lime": "Light green snout",
  "block.minecraft.banner.piglin.magenta": "Light purple snout",
  "block.minecraft.banner.piglin.orange": "Orange snout",
  "block.minecraft.banner.piglin.pink": "Pink snout",
  "block.minecraft.banner.piglin.purple": "Purple snout",
  "block.minecraft.banner.piglin.red": "Scarlet snout",
  "block.minecraft.banner.piglin.white": "White snout",
  "block.minecraft.banner.piglin.yellow": "Yellow snout",
  "block.minecraft.banner.rhombus.black": "Black lozenge",
  "block.minecraft.banner.rhombus.blue": "Blue lozenge",
  "block.minecraft.banner.rhombus.brown": "Brown lozenge",
  "block.minecraft.banner.rhombus.cyan": "Ocean blue lozenge",
  "block.minecraft.banner.rhombus.gray": "Gray lozenge",
  "block.minecraft.banner.rhombus.green": "Green lozenge",
  "block.minecraft.banner.rhombus.light_blue": "Light blue lozenge",
  "block.minecraft.banner.rhombus.light_gray": "Light gray lozenge",
  "block.minecraft.banner.rhombus.lime": "Light green lozenge",
  "block.minecraft.banner.rhombus.magenta": "Light purple lozenge",
  "block.minecraft.banner.rhombus.orange": "Orange lozenge",
  "block.minecraft.banner.rhombus.pink": "Pink lozenge",
  "block.minecraft.banner.rhombus.purple": "Purple lozenge",
  "block.minecraft.banner.rhombus.red": "Scarlet lozenge",
  "block.minecraft.banner.rhombus.white": "White lozenge",
  "block.minecraft.banner.rhombus.yellow": "Yellow lozenge",
  "block.minecraft.banner.skull.black": "Black skull charge",
  "block.minecraft.banner.skull.blue": "Blue skull charge",
  "block.minecraft.banner.skull.brown": "Brown skull charge",
  "block.minecraft.banner.skull.cyan": "Ocean blue skull charge",
  "block.minecraft.banner.skull.gray": "Gray skull charge",
  "block.minecraft.banner.skull.green": "Green skull charge",
  "block.minecraft.banner.skull.light_blue": "Light blue skull charge",
  "block.minecraft.banner.skull.light_gray": "Light gray skull charge",
  "block.minecraft.banner.skull.lime": "Light green skull charge",
  "block.minecraft.banner.skull.magenta": "Light purple skull charge",
  "block.minecraft.banner.skull.orange": "Orange skull charge",
  "block.minecraft.banner.skull.pink": "Pink skull charge",
  "block.minecraft.banner.skull.purple": "Purple skull charge",
  "block.minecraft.banner.skull.red": "Scarlet skull charge",
  "block.minecraft.banner.skull.white": "White skull charge",
  "block.minecraft.banner.skull.yellow": "Yellow skull charge",
  "block.minecraft.banner.small_stripes.black": "Black paly",
  "block.minecraft.banner.small_stripes.blue": "Blue paly",
  "block.minecraft.banner.small_stripes.brown": "Brown paly",
  "block.minecraft.banner.small_stripes.cyan": "Ocean blue paly",
  "block.minecraft.banner.small_stripes.gray": "Gray paly",
  "block.minecraft.banner.small_stripes.green": "Green paly",
  "block.minecraft.banner.small_stripes.light_blue": "Light blue paly",
  "block.minecraft.banner.small_stripes.light_gray": "Light gray paly",
  "block.minecraft.banner.small_stripes.lime": "Light green paly",
  "block.minecraft.banner.small_stripes.magenta": "Light purple paly",
  "block.minecraft.banner.small_stripes.orange": "Orange paly",
  "block.minecraft.banner.small_stripes.pink": "Pink paly",
  "block.minecraft.banner.small_stripes.purple": "Purple paly",
  "block.minecraft.banner.small_stripes.red": "Scarlet paly",
  "block.minecraft.banner.small_stripes.white": "White paly",
  "block.minecraft.banner.small_stripes.yellow": "Yellow paly",
  "block.minecraft.banner.square_bottom_left.black": "Black base dexter canton",
  "block.minecraft.banner.square_bottom_left.blue": "Blue base dexter canton",
  "block.minecraft.banner.square_bottom_left.brown": "Brown base dexter canton",
  "block.minecraft.banner.square_bottom_left.cyan": "Ocean blue base dexter canton",
  "block.minecraft.banner.square_bottom_left.gray": "Gray base dexter canton",
  "block.minecraft.banner.square_bottom_left.green": "Green base dexter canton",
  "block.minecraft.banner.square_bottom_left.light_blue": "Light blue base dexter canton",
  "block.minecraft.banner.square_bottom_left.light_gray": "Light gray base dexter canton",
  "block.minecraft.banner.square_bottom_left.lime": "Light green base dexter canton",
  "block.minecraft.banner.square_bottom_left.magenta": "Light purple base dexter canton",
  "block.minecraft.banner.square_bottom_left.orange": "Orange base dexter canton",
  "block.minecraft.banner.square_bottom_left.pink": "Pink base dexter canton",
  "block.minecraft.banner.square_bottom_left.purple": "Purple base dexter canton",
  "block.minecraft.banner.square_bottom_left.red": "Scarlet base dexter canton",
  "block.minecraft.banner.square_bottom_left.white": "White base dexter canton",
  "block.minecraft.banner.square_bottom_left.yellow": "Yellow base dexter canton",
  "block.minecraft.banner.square_bottom_right.black": "Black base sinister canton",
  "block.minecraft.banner.square_bottom_right.blue": "Blue base sinister canton",
  "block.minecraft.banner.square_bottom_right.brown": "Brown base sinister canton",
  "block.minecraft.banner.square_bottom_right.cyan": "Ocean blue base sinister canton",
  "block.minecraft.banner.square_bottom_right.gray": "Gray base sinister canton",
  "block.minecraft.banner.square_bottom_right.green": "Green base sinister canton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Light blue base sinister canton",
  "block.minecraft.banner.square_bottom_right.light_gray": "Light gray base sinister canton",
  "block.minecraft.banner.square_bottom_right.lime": "Light green base sinister canton",
  "block.minecraft.banner.square_bottom_right.magenta": "Light purple base sinister canton",
  "block.minecraft.banner.square_bottom_right.orange": "Orange base sinister canton",
  "block.minecraft.banner.square_bottom_right.pink": "Pink base sinister canton",
  "block.minecraft.banner.square_bottom_right.purple": "Purple base sinister canton",
  "block.minecraft.banner.square_bottom_right.red": "Scarlet base sinister canton",
  "block.minecraft.banner.square_bottom_right.white": "White base sinister canton",
  "block.minecraft.banner.square_bottom_right.yellow": "Yellow base sinister canton",
  "block.minecraft.banner.square_top_left.black": "Black chief dexter canton",
  "block.minecraft.banner.square_top_left.blue": "Blue chief dexter canton",
  "block.minecraft.banner.square_top_left.brown": "Brown chief dexter canton",
  "block.minecraft.banner.square_top_left.cyan": "Ocean blue chief dexter canton",
  "block.minecraft.banner.square_top_left.gray": "Gray chief dexter canton",
  "block.minecraft.banner.square_top_left.green": "Green chief dexter canton",
  "block.minecraft.banner.square_top_left.light_blue": "Light blue chief dexter canton",
  "block.minecraft.banner.square_top_left.light_gray": "Light gray chief dexter canton",
  "block.minecraft.banner.square_top_left.lime": "Light green chief dexter canton",
  "block.minecraft.banner.square_top_left.magenta": "Light purple chief dexter canton",
  "block.minecraft.banner.square_top_left.orange": "Orange chief dexter canton",
  "block.minecraft.banner.square_top_left.pink": "Pink chief dexter canton",
  "block.minecraft.banner.square_top_left.purple": "Purple chief dexter canton",
  "block.minecraft.banner.square_top_left.red": "Scarlet chief dexter canton",
  "block.minecraft.banner.square_top_left.white": "White chief dexter canton",
  "block.minecraft.banner.square_top_left.yellow": "Yellow chief dexter canton",
  "block.minecraft.banner.square_top_right.black": "Black chief sinister canton",
  "block.minecraft.banner.square_top_right.blue": "Blue chief sinister canton",
  "block.minecraft.banner.square_top_right.brown": "Brown chief sinister canton",
  "block.minecraft.banner.square_top_right.cyan": "Ocean blue chief sinister canton",
  "block.minecraft.banner.square_top_right.gray": "Gray chief sinister canton",
  "block.minecraft.banner.square_top_right.green": "Green chief sinister canton",
  "block.minecraft.banner.square_top_right.light_blue": "Light blue chief sinister canton",
  "block.minecraft.banner.square_top_right.light_gray": "Light gray chief sinister canton",
  "block.minecraft.banner.square_top_right.lime": "Light green chief sinister canton",
  "block.minecraft.banner.square_top_right.magenta": "Light purple chief sinister canton",
  "block.minecraft.banner.square_top_right.orange": "Orange chief sinister canton",
  "block.minecraft.banner.square_top_right.pink": "Pink chief sinister canton",
  "block.minecraft.banner.square_top_right.purple": "Purple chief sinister canton",
  "block.minecraft.banner.square_top_right.red": "Scarlet chief sinister canton",
  "block.minecraft.banner.square_top_right.white": "White chief sinister canton",
  "block.minecraft.banner.square_top_right.yellow": "Yellow chief sinister canton",
  "block.minecraft.banner.straight_cross.black": "Black cross",
  "block.minecraft.banner.straight_cross.blue": "Blue cross",
  "block.minecraft.banner.straight_cross.brown": "Brown cross",
  "block.minecraft.banner.straight_cross.cyan": "Ocean blue cross",
  "block.minecraft.banner.straight_cross.gray": "Gray cross",
  "block.minecraft.banner.straight_cross.green": "Green cross",
  "block.minecraft.banner.straight_cross.light_blue": "Light blue cross",
  "block.minecraft.banner.straight_cross.light_gray": "Light gray cross",
  "block.minecraft.banner.straight_cross.lime": "Light green cross",
  "block.minecraft.banner.straight_cross.magenta": "Light purple cross",
  "block.minecraft.banner.straight_cross.orange": "Orange cross",
  "block.minecraft.banner.straight_cross.pink": "Pink cross",
  "block.minecraft.banner.straight_cross.purple": "Purple cross",
  "block.minecraft.banner.straight_cross.red": "Scarlet cross",
  "block.minecraft.banner.straight_cross.white": "White cross",
  "block.minecraft.banner.straight_cross.yellow": "Yellow cross",
  "block.minecraft.banner.stripe_bottom.black": "Black base",
  "block.minecraft.banner.stripe_bottom.blue": "Blue base",
  "block.minecraft.banner.stripe_bottom.brown": "Brown base",
  "block.minecraft.banner.stripe_bottom.cyan": "Ocean blue base",
  "block.minecraft.banner.stripe_bottom.gray": "Gray base",
  "block.minecraft.banner.stripe_bottom.green": "Green base",
  "block.minecraft.banner.stripe_bottom.light_blue": "Light blue base",
  "block.minecraft.banner.stripe_bottom.light_gray": "Light gray base",
  "block.minecraft.banner.stripe_bottom.lime": "Light green base",
  "block.minecraft.banner.stripe_bottom.magenta": "Light purple base",
  "block.minecraft.banner.stripe_bottom.orange": "Orange base",
  "block.minecraft.banner.stripe_bottom.pink": "Pink base",
  "block.minecraft.banner.stripe_bottom.purple": "Purple base",
  "block.minecraft.banner.stripe_bottom.red": "Scarlet base",
  "block.minecraft.banner.stripe_bottom.white": "White base",
  "block.minecraft.banner.stripe_bottom.yellow": "Yellow base",
  "block.minecraft.banner.stripe_center.black": "Black pale",
  "block.minecraft.banner.stripe_center.blue": "Blue pale",
  "block.minecraft.banner.stripe_center.brown": "Brown pale",
  "block.minecraft.banner.stripe_center.cyan": "Ocean blue pale",
  "block.minecraft.banner.stripe_center.gray": "Gray pale",
  "block.minecraft.banner.stripe_center.green": "Green pale",
  "block.minecraft.banner.stripe_center.light_blue": "Light blue pale",
  "block.minecraft.banner.stripe_center.light_gray": "Light gray pale",
  "block.minecraft.banner.stripe_center.lime": "Light green pale",
  "block.minecraft.banner.stripe_center.magenta": "Light purple pale",
  "block.minecraft.banner.stripe_center.orange": "Orange pale",
  "block.minecraft.banner.stripe_center.pink": "Pink pale",
  "block.minecraft.banner.stripe_center.purple": "Purple pale",
  "block.minecraft.banner.stripe_center.red": "Scarlet pale",
  "block.minecraft.banner.stripe_center.white": "White pale",
  "block.minecraft.banner.stripe_center.yellow": "Yellow pale",
  "block.minecraft.banner.stripe_downleft.black": "Black bend sinister",
  "block.minecraft.banner.stripe_downleft.blue": "Blue bend sinister",
  "block.minecraft.banner.stripe_downleft.brown": "Brown bend sinister",
  "block.minecraft.banner.stripe_downleft.cyan": "Ocean blue bend sinister",
  "block.minecraft.banner.stripe_downleft.gray": "Gray bend sinister",
  "block.minecraft.banner.stripe_downleft.green": "Green bend sinister",
  "block.minecraft.banner.stripe_downleft.light_blue": "Light blue bend sinister",
  "block.minecraft.banner.stripe_downleft.light_gray": "Light gray bend sinister",
  "block.minecraft.banner.stripe_downleft.lime": "Light green bend sinister",
  "block.minecraft.banner.stripe_downleft.magenta": "Light purple bend sinister",
  "block.minecraft.banner.stripe_downleft.orange": "Orange bend sinister",
  "block.minecraft.banner.stripe_downleft.pink": "Pink bend sinister",
  "block.minecraft.banner.stripe_downleft.purple": "Purple bend sinister",
  "block.minecraft.banner.stripe_downleft.red": "Scarlet bend sinister",
  "block.minecraft.banner.stripe_downleft.white": "White bend sinister",
  "block.minecraft.banner.stripe_downleft.yellow": "Yellow bend sinister",
  "block.minecraft.banner.stripe_downright.black": "Black bend",
  "block.minecraft.banner.stripe_downright.blue": "Blue bend",
  "block.minecraft.banner.stripe_downright.brown": "Brown bend",
  "block.minecraft.banner.stripe_downright.cyan": "Ocean blue bend",
  "block.minecraft.banner.stripe_downright.gray": "Gray bend",
  "block.minecraft.banner.stripe_downright.green": "Green bend",
  "block.minecraft.banner.stripe_downright.light_blue": "Light blue bend",
  "block.minecraft.banner.stripe_downright.light_gray": "Light gray bend",
  "block.minecraft.banner.stripe_downright.lime": "Light green bend",
  "block.minecraft.banner.stripe_downright.magenta": "Light purple bend",
  "block.minecraft.banner.stripe_downright.orange": "Orange bend",
  "block.minecraft.banner.stripe_downright.pink": "Pink bend",
  "block.minecraft.banner.stripe_downright.purple": "Purple bend",
  "block.minecraft.banner.stripe_downright.red": "Scarlet bend",
  "block.minecraft.banner.stripe_downright.white": "White bend",
  "block.minecraft.banner.stripe_downright.yellow": "Yellow bend",
  "block.minecraft.banner.stripe_left.black": "Black pale dexter",
  "block.minecraft.banner.stripe_left.blue": "Blue pale dexter",
  "block.minecraft.banner.stripe_left.brown": "Brown pale dexter",
  "block.minecraft.banner.stripe_left.cyan": "Ocean blue pale dexter",
  "block.minecraft.banner.stripe_left.gray": "Gray pale dexter",
  "block.minecraft.banner.stripe_left.green": "Green pale dexter",
  "block.minecraft.banner.stripe_left.light_blue": "Light blue pale dexter",
  "block.minecraft.banner.stripe_left.light_gray": "Light gray pale dexter",
  "block.minecraft.banner.stripe_left.lime": "Light green pale dexter",
  "block.minecraft.banner.stripe_left.magenta": "Light purple pale dexter",
  "block.minecraft.banner.stripe_left.orange": "Orange pale dexter",
  "block.minecraft.banner.stripe_left.pink": "Pink pale dexter",
  "block.minecraft.banner.stripe_left.purple": "Purple pale dexter",
  "block.minecraft.banner.stripe_left.red": "Scarlet pale dexter",
  "block.minecraft.banner.stripe_left.white": "White pale dexter",
  "block.minecraft.banner.stripe_left.yellow": "Yellow pale dexter",
  "block.minecraft.banner.stripe_middle.black": "Black fess",
  "block.minecraft.banner.stripe_middle.blue": "Blue fess",
  "block.minecraft.banner.stripe_middle.brown": "Brown fess",
  "block.minecraft.banner.stripe_middle.cyan": "Ocean blue fess",
  "block.minecraft.banner.stripe_middle.gray": "Gray fess",
  "block.minecraft.banner.stripe_middle.green": "Green fess",
  "block.minecraft.banner.stripe_middle.light_blue": "Light blue fess",
  "block.minecraft.banner.stripe_middle.light_gray": "Light gray fess",
  "block.minecraft.banner.stripe_middle.lime": "Light green fess",
  "block.minecraft.banner.stripe_middle.magenta": "Light purple fess",
  "block.minecraft.banner.stripe_middle.orange": "Orange fess",
  "block.minecraft.banner.stripe_middle.pink": "Pink fess",
  "block.minecraft.banner.stripe_middle.purple": "Purple fess",
  "block.minecraft.banner.stripe_middle.red": "Scarlet fess",
  "block.minecraft.banner.stripe_middle.white": "White fess",
  "block.minecraft.banner.stripe_middle.yellow": "Yellow fess",
  "block.minecraft.banner.stripe_right.black": "Black pale sinister",
  "block.minecraft.banner.stripe_right.blue": "Blue pale sinister",
  "block.minecraft.banner.stripe_right.brown": "Brown pale sinister",
  "block.minecraft.banner.stripe_right.cyan": "Ocean blue pale sinister",
  "block.minecraft.banner.stripe_right.gray": "Gray pale sinister",
  "block.minecraft.banner.stripe_right.green": "Green pale sinister",
  "block.minecraft.banner.stripe_right.light_blue": "Light blue pale sinister",
  "block.minecraft.banner.stripe_right.light_gray": "Light gray pale sinister",
  "block.minecraft.banner.stripe_right.lime": "Light green pale sinister",
  "block.minecraft.banner.stripe_right.magenta": "Light purple pale sinister",
  "block.minecraft.banner.stripe_right.orange": "Orange pale sinister",
  "block.minecraft.banner.stripe_right.pink": "Pink pale sinister",
  "block.minecraft.banner.stripe_right.purple": "Purple pale sinister",
  "block.minecraft.banner.stripe_right.red": "Scarlet pale sinister",
  "block.minecraft.banner.stripe_right.white": "White pale sinister",
  "block.minecraft.banner.stripe_right.yellow": "Yellow pale sinister",
  "block.minecraft.banner.stripe_top.black": "Black chief",
  "block.minecraft.banner.stripe_top.blue": "Blue chief",
  "block.minecraft.banner.stripe_top.brown": "Brown chief",
  "block.minecraft.banner.stripe_top.cyan": "Ocean blue chief",
  "block.minecraft.banner.stripe_top.gray": "Gray chief",
  "block.minecraft.banner.stripe_top.green": "Green chief",
  "block.minecraft.banner.stripe_top.light_blue": "Light blue chief",
  "block.minecraft.banner.stripe_top.light_gray": "Light gray chief",
  "block.minecraft.banner.stripe_top.lime": "Light green chief",
  "block.minecraft.banner.stripe_top.magenta": "Light purple chief",
  "block.minecraft.banner.stripe_top.orange": "Orange chief",
  "block.minecraft.banner.stripe_top.pink": "Pink chief",
  "block.minecraft.banner.stripe_top.purple": "Purple chief",
  "block.minecraft.banner.stripe_top.red": "Scarlet chief",
  "block.minecraft.banner.stripe_top.white": "White chief",
  "block.minecraft.banner.stripe_top.yellow": "Yellow chief",
  "block.minecraft.banner.triangle_bottom.black": "Black chevron",
  "block.minecraft.banner.triangle_bottom.blue": "Blue chevron",
  "block.minecraft.banner.triangle_bottom.brown": "Brown chevron",
  "block.minecraft.banner.triangle_bottom.cyan": "Ocean blue chevron",
  "block.minecraft.banner.triangle_bottom.gray": "Gray chevron",
  "block.minecraft.banner.triangle_bottom.green": "Green chevron",
  "block.minecraft.banner.triangle_bottom.light_blue": "Light blue chevron",
  "block.minecraft.banner.triangle_bottom.light_gray": "Light gray chevron",
  "block.minecraft.banner.triangle_bottom.lime": "Light green chevron",
  "block.minecraft.banner.triangle_bottom.magenta": "Light purple chevron",
  "block.minecraft.banner.triangle_bottom.orange": "Orange chevron",
  "block.minecraft.banner.triangle_bottom.pink": "Pink chevron",
  "block.minecraft.banner.triangle_bottom.purple": "Purple chevron",
  "block.minecraft.banner.triangle_bottom.red": "Scarlet chevron",
  "block.minecraft.banner.triangle_bottom.white": "White chevron",
  "block.minecraft.banner.triangle_bottom.yellow": "Yellow chevron",
  "block.minecraft.banner.triangle_top.black": "Black inverted chevron",
  "block.minecraft.banner.triangle_top.blue": "Blue inverted chevron",
  "block.minecraft.banner.triangle_top.brown": "Brown inverted chevron",
  "block.minecraft.banner.triangle_top.cyan": "Ocean blue inverted chevron",
  "block.minecraft.banner.triangle_top.gray": "Gray inverted chevron",
  "block.minecraft.banner.triangle_top.green": "Green inverted chevron",
  "block.minecraft.banner.triangle_top.light_blue": "Light blue inverted chevron",
  "block.minecraft.banner.triangle_top.light_gray": "Light gray inverted chevron",
  "block.minecraft.banner.triangle_top.lime": "Light green inverted chevron",
  "block.minecraft.banner.triangle_top.magenta": "Light purple inverted chevron",
  "block.minecraft.banner.triangle_top.orange": "Orange inverted chevron",
  "block.minecraft.banner.triangle_top.pink": "Pink inverted chevron",
  "block.minecraft.banner.triangle_top.purple": "Purple inverted chevron",
  "block.minecraft.banner.triangle_top.red": "Scarlet inverted chevron",
  "block.minecraft.banner.triangle_top.white": "White inverted chevron",
  "block.minecraft.banner.triangle_top.yellow": "Yellow inverted chevron",
  "block.minecraft.banner.triangles_bottom.black": "Black base indented",
  "block.minecraft.banner.triangles_bottom.blue": "Blue base indented",
  "block.minecraft.banner.triangles_bottom.brown": "Brown base indented",
  "block.minecraft.banner.triangles_bottom.cyan": "Ocean blue base indented",
  "block.minecraft.banner.triangles_bottom.gray": "Gray base indented",
  "block.minecraft.banner.triangles_bottom.green": "Green base indented",
  "block.minecraft.banner.triangles_bottom.light_blue": "Light blue base indented",
  "block.minecraft.banner.triangles_bottom.light_gray": "Light gray base indented",
  "block.minecraft.banner.triangles_bottom.lime": "Light green base indented",
  "block.minecraft.banner.triangles_bottom.magenta": "Light purple base indented",
  "block.minecraft.banner.triangles_bottom.orange": "Orange base indented",
  "block.minecraft.banner.triangles_bottom.pink": "Pink base indented",
  "block.minecraft.banner.triangles_bottom.purple": "Purple base indented",
  "block.minecraft.banner.triangles_bottom.red": "Scarlet base indented",
  "block.minecraft.banner.triangles_bottom.white": "White base indented",
  "block.minecraft.banner.triangles_bottom.yellow": "Yellow base indented",
  "block.minecraft.banner.triangles_top.black": "Black chief indented",
  "block.minecraft.banner.triangles_top.blue": "Blue chief indented",
  "block.minecraft.banner.triangles_top.brown": "Brown chief indented",
  "block.minecraft.banner.triangles_top.cyan": "Ocean blue chief indented",
  "block.minecraft.banner.triangles_top.gray": "Gray chief indented",
  "block.minecraft.banner.triangles_top.green": "Green chief indented",
  "block.minecraft.banner.triangles_top.light_blue": "Light blue chief indented",
  "block.minecraft.banner.triangles_top.light_gray": "Light gray chief indented",
  "block.minecraft.banner.triangles_top.lime": "Light green chief indented",
  "block.minecraft.banner.triangles_top.magenta": "Light purple chief indented",
  "block.minecraft.banner.triangles_top.orange": "Orange chief indented",
  "block.minecraft.banner.triangles_top.pink": "Pink chief indented",
  "block.minecraft.banner.triangles_top.purple": "Purple chief indented",
  "block.minecraft.banner.triangles_top.red": "Scarlet chief indented",
  "block.minecraft.banner.triangles_top.white": "White chief indented",
  "block.minecraft.banner.triangles_top.yellow": "Yellow chief indented",
  "block.minecraft.barrel": "Barrrel",
  "block.minecraft.barrier": "Invisible wall",
  "block.minecraft.basalt": "Rock o' magma",
  "block.minecraft.beacon": "Buoy o' light",
  "block.minecraft.beacon.primary": "Main cannon",
  "block.minecraft.beacon.secondary": "Secondary cannon",
  "block.minecraft.bed.no_sleep": "Ye cant nap till' the moon comes o' the storm hits hard",
  "block.minecraft.bed.not_safe": "Don't be takin' rest, mutinies be about",
  "block.minecraft.bed.obstructed": "This restin' place be blocked",
  "block.minecraft.bed.occupied": "This sleeping place is taken by a landlubber",
  "block.minecraft.bed.too_far_away": "You shan't sit yer booty down; your quarters is much too far away",
  "block.minecraft.bedrock": "The har'est rock",
  "block.minecraft.bee_nest": "Crow's nest o' bee",
  "block.minecraft.beehive": "Vessel o' bee",
  "block.minecraft.beetroots": "Bloody taters",
  "block.minecraft.bell": "Landlubbers' nightmare",
  "block.minecraft.big_dripleaf": "Huge venus flytrap",
  "block.minecraft.big_dripleaf_stem": "Twig o' venus flytrap",
  "block.minecraft.birch_button": "Knob o' birch",
  "block.minecraft.birch_door": "Door o' birch",
  "block.minecraft.birch_fence": "Picket o' birch",
  "block.minecraft.birch_fence_gate": "Picket gate o' birch",
  "block.minecraft.birch_hanging_sign": "Danglin' seal o' birch",
  "block.minecraft.birch_leaves": "Leaves o' birch",
  "block.minecraft.birch_log": "Log o' birch",
  "block.minecraft.birch_planks": "Planks o' birch",
  "block.minecraft.birch_pressure_plate": "Booby trap o' birch",
  "block.minecraft.birch_sapling": "Birch meager shrub",
  "block.minecraft.birch_shelf": "Rack o' birch",
  "block.minecraft.birch_sign": "Seal o' birch",
  "block.minecraft.birch_slab": "Slab o' birch",
  "block.minecraft.birch_stairs": "Stairs o' birch",
  "block.minecraft.birch_trapdoor": "Hatch o' birch",
  "block.minecraft.birch_wall_hanging_sign": "Danglin' wall seal o' birch",
  "block.minecraft.birch_wall_sign": "Wall seal o' birch",
  "block.minecraft.birch_wood": "Birch timber",
  "block.minecraft.black_banner": "Black flag",
  "block.minecraft.black_bed": "Black bunk",
  "block.minecraft.black_candle": "Black glim",
  "block.minecraft.black_candle_cake": "Duff with black glim",
  "block.minecraft.black_carpet": "Black rug",
  "block.minecraft.black_concrete": "Black cement",
  "block.minecraft.black_concrete_powder": "Black cement dusts",
  "block.minecraft.black_glazed_terracotta": "Black pricey mosaic",
  "block.minecraft.black_shulker_box": "Black shulker box",
  "block.minecraft.black_stained_glass": "Black crystal",
  "block.minecraft.black_stained_glass_pane": "Black porthole",
  "block.minecraft.black_terracotta": "Black ancient clay",
  "block.minecraft.black_wool": "Black cloth",
  "block.minecraft.blackstone": "Rock o' black",
  "block.minecraft.blackstone_slab": "Slab o' rock o' black",
  "block.minecraft.blackstone_stairs": "Stairs o' rock o' black",
  "block.minecraft.blackstone_wall": "Wall o' rock o' black",
  "block.minecraft.blast_furnace": "Blast oven",
  "block.minecraft.blue_banner": "Blue flag",
  "block.minecraft.blue_bed": "Blue bunk",
  "block.minecraft.blue_candle": "Blue glim",
  "block.minecraft.blue_candle_cake": "Duff with blue glim",
  "block.minecraft.blue_carpet": "Blue rug",
  "block.minecraft.blue_concrete": "Blue cement",
  "block.minecraft.blue_concrete_powder": "Blue cement dusts",
  "block.minecraft.blue_glazed_terracotta": "Blue pricey mosaic",
  "block.minecraft.blue_ice": "Blue frost",
  "block.minecraft.blue_orchid": "Beauty o' the swamps",
  "block.minecraft.blue_shulker_box": "Blue shulker box",
  "block.minecraft.blue_stained_glass": "Blue crystal",
  "block.minecraft.blue_stained_glass_pane": "Blue porthole",
  "block.minecraft.blue_terracotta": "Blue ancient clay",
  "block.minecraft.blue_wool": "Blue cloth",
  "block.minecraft.bone_block": "Chunk o' bone",
  "block.minecraft.bookshelf": "Stack o' knowledge",
  "block.minecraft.brain_coral": "Walnut coral",
  "block.minecraft.brain_coral_block": "Chunk o' walnut coral",
  "block.minecraft.brain_coral_fan": "Brain coral waf'r",
  "block.minecraft.brain_coral_wall_fan": "Brain coral wall waf'r",
  "block.minecraft.brewing_stand": "Mixin' station",
  "block.minecraft.brick_slab": "Slab o' brick",
  "block.minecraft.brick_stairs": "Stairs o' brick o' clay",
  "block.minecraft.brick_wall": "Wall o' bricks o' clay",
  "block.minecraft.bricks": "Bricks o' clay",
  "block.minecraft.brown_banner": "Brown flag",
  "block.minecraft.brown_bed": "Brown bunk",
  "block.minecraft.brown_candle": "Brown glim",
  "block.minecraft.brown_candle_cake": "Duff with brown glim",
  "block.minecraft.brown_carpet": "Brown rug",
  "block.minecraft.brown_concrete": "Brown cement",
  "block.minecraft.brown_concrete_powder": "Brown cement dusts",
  "block.minecraft.brown_glazed_terracotta": "Brown pricey mosaic",
  "block.minecraft.brown_mushroom": "Brown shroom",
  "block.minecraft.brown_mushroom_block": "Chunk o' brown shroom",
  "block.minecraft.brown_shulker_box": "Brown shulker box",
  "block.minecraft.brown_stained_glass": "Brown crystal",
  "block.minecraft.brown_stained_glass_pane": "Brown porthole",
  "block.minecraft.brown_terracotta": "Brown ancient clay",
  "block.minecraft.brown_wool": "Brown cloth",
  "block.minecraft.bubble_column": "Tower o' bubbles",
  "block.minecraft.bubble_coral": "Cyst coral",
  "block.minecraft.bubble_coral_block": "Chunk o' cyst coral",
  "block.minecraft.bubble_coral_fan": "Cyst coral waf'r",
  "block.minecraft.bubble_coral_wall_fan": "Cyst coral wall waf'r",
  "block.minecraft.budding_amethyst": "Buddin' purple gems",
  "block.minecraft.bush": "Shrub",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Jewel o' th' desert",
  "block.minecraft.cake": "Duff",
  "block.minecraft.calcite": "Fool's quartz",
  "block.minecraft.calibrated_sculk_sensor": "Calibrated sensor o' silence",
  "block.minecraft.campfire": "Campfire",
  "block.minecraft.candle": "Glim",
  "block.minecraft.candle_cake": "Duff with glim",
  "block.minecraft.carrots": "Orange veggies",
  "block.minecraft.cartography_table": "Cap'n's mappin' desk",
  "block.minecraft.carved_pumpkin": "Carv'd gourd squash",
  "block.minecraft.cauldron": "Pot",
  "block.minecraft.cave_air": "Cave breeze",
  "block.minecraft.cave_vines": "Cave swingers",
  "block.minecraft.cave_vines_plant": "Cave swingers plant",
  "block.minecraft.chain": "Chain o' steel",
  "block.minecraft.chain_command_block": "Chained order block",
  "block.minecraft.cherry_button": "Knob o' cherry",
  "block.minecraft.cherry_door": "Door o' cherry",
  "block.minecraft.cherry_fence": "Picket o' cherry",
  "block.minecraft.cherry_fence_gate": "Picket gate o' cherry",
  "block.minecraft.cherry_hanging_sign": "Danglin' seal o' cherry",
  "block.minecraft.cherry_leaves": "Leaves o' cherry",
  "block.minecraft.cherry_log": "Log o' cherry",
  "block.minecraft.cherry_planks": "Planks o' cherry",
  "block.minecraft.cherry_pressure_plate": "Booby trap o' cherry",
  "block.minecraft.cherry_sapling": "Cherry meager shrub",
  "block.minecraft.cherry_shelf": "Rack o' cherry",
  "block.minecraft.cherry_sign": "Seal o' cherry",
  "block.minecraft.cherry_slab": "Slab o' cherry",
  "block.minecraft.cherry_stairs": "Stairs o' cherry",
  "block.minecraft.cherry_trapdoor": "Hatch o' cherry",
  "block.minecraft.cherry_wall_hanging_sign": "Danglin' wall seal o' cherry",
  "block.minecraft.cherry_wall_sign": "Wall seal o' cherry",
  "block.minecraft.cherry_wood": "Wood o' cherry",
  "block.minecraft.chest": "Coffer",
  "block.minecraft.chipped_anvil": "Chipped slab o' fixin'",
  "block.minecraft.chiseled_bookshelf": "Carv'd stack o' knowledge",
  "block.minecraft.chiseled_copper": "Carv'd copper",
  "block.minecraft.chiseled_deepslate": "Carv'd tough rock",
  "block.minecraft.chiseled_nether_bricks": "Carv'd bricks o' Nether",
  "block.minecraft.chiseled_polished_blackstone": "Good look'n carv'd rock o' black",
  "block.minecraft.chiseled_quartz_block": "Carv'd chunk o' white rock",
  "block.minecraft.chiseled_red_sandstone": "Carv'd scarlet stone o' sands",
  "block.minecraft.chiseled_resin_bricks": "Carv'd bricks o' treacle ooze",
  "block.minecraft.chiseled_sandstone": "Carv'd stone o' sands",
  "block.minecraft.chiseled_stone_bricks": "Carv'd bricks o' rock",
  "block.minecraft.chiseled_tuff": "Carv'd rock o' ash",
  "block.minecraft.chiseled_tuff_bricks": "Bricks o' carv'd rock o' ash",
  "block.minecraft.chorus_flower": "Tall one's flower",
  "block.minecraft.chorus_plant": "Tall one's tree",
  "block.minecraft.clay": "Solid mud",
  "block.minecraft.closed_eyeblossom": "Closed eye o' th' night",
  "block.minecraft.coal_block": "Chunk o' fuel",
  "block.minecraft.coal_ore": "Orrre o' fuel",
  "block.minecraft.coarse_dirt": "Rough filth",
  "block.minecraft.cobbled_deepslate": "Tough pebbles",
  "block.minecraft.cobbled_deepslate_slab": "Slab o' tough pebbles",
  "block.minecraft.cobbled_deepslate_stairs": "Stairs o' tough pebbles",
  "block.minecraft.cobbled_deepslate_wall": "Wall o' tough pebbles",
  "block.minecraft.cobblestone": "Pebbles",
  "block.minecraft.cobblestone_slab": "Slab o' pebbles",
  "block.minecraft.cobblestone_stairs": "Stairs o' pebbles",
  "block.minecraft.cobblestone_wall": "Wall o' pebbles",
  "block.minecraft.cobweb": "Web o' night bug",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Order block",
  "block.minecraft.comparator": "Redstone compaaratorrr",
  "block.minecraft.composter": "Rottin' box",
  "block.minecraft.conduit": "Source o' th' seas",
  "block.minecraft.copper_bars": "Barrrs o' copper",
  "block.minecraft.copper_block": "Chunk o' copper",
  "block.minecraft.copper_bulb": "Deck lanterrrn o' copper",
  "block.minecraft.copper_chain": "Chain o' copper",
  "block.minecraft.copper_chest": "Coffer o' copper",
  "block.minecraft.copper_door": "Door o' copper",
  "block.minecraft.copper_golem_statue": "Statue o' copper matey",
  "block.minecraft.copper_grate": "Grate o' copper",
  "block.minecraft.copper_lantern": "Lanterrrn o' copper",
  "block.minecraft.copper_ore": "Orrre o' copper",
  "block.minecraft.copper_torch": "Torch o' copper",
  "block.minecraft.copper_trapdoor": "Hatch o' copper",
  "block.minecraft.copper_wall_torch": "Wall torch o' copper",
  "block.minecraft.cornflower": "Cornflowarrr",
  "block.minecraft.cracked_deepslate_bricks": "Cracked bricks o' tough rock",
  "block.minecraft.cracked_deepslate_tiles": "Cracked tiles o' tough rock",
  "block.minecraft.cracked_nether_bricks": "Cracked bricks o' Nether",
  "block.minecraft.cracked_polished_blackstone_bricks": "Cracked good-lookin' bricks o' rock o' black",
  "block.minecraft.cracked_stone_bricks": "Cracked bricks o' rock",
  "block.minecraft.crafter": "Craftin' matey",
  "block.minecraft.crafting_table": "Craftin' table",
  "block.minecraft.creaking_heart": "Heart o' creakin'",
  "block.minecraft.creeper_head": "Creeper skull",
  "block.minecraft.creeper_wall_head": "Creeper wall skull",
  "block.minecraft.crimson_button": "Knob o' ichor",
  "block.minecraft.crimson_door": "Door o' ichor",
  "block.minecraft.crimson_fence": "Picket o' ichor",
  "block.minecraft.crimson_fence_gate": "Picket gate o' ichor",
  "block.minecraft.crimson_fungus": "Fungus o' ichor",
  "block.minecraft.crimson_hanging_sign": "Danglin' seal o' ichor",
  "block.minecraft.crimson_hyphae": "Ichor hyphae",
  "block.minecraft.crimson_nylium": "Scarlet moss o' ichor",
  "block.minecraft.crimson_planks": "Planks o' ichor",
  "block.minecraft.crimson_pressure_plate": "Booby trap o' ichor",
  "block.minecraft.crimson_roots": "Tendrils o' ichor",
  "block.minecraft.crimson_shelf": "Rack o' Ichor",
  "block.minecraft.crimson_sign": "Seal o' ichor",
  "block.minecraft.crimson_slab": "Slab o' ichor",
  "block.minecraft.crimson_stairs": "Stairs o' ichor",
  "block.minecraft.crimson_stem": "Stem o' ichor",
  "block.minecraft.crimson_trapdoor": "Hatch o' ichor",
  "block.minecraft.crimson_wall_hanging_sign": "Wall seal o' ichor",
  "block.minecraft.crimson_wall_sign": "Wall seal o' ichor",
  "block.minecraft.crying_obsidian": "Rock o' true sobbin'",
  "block.minecraft.cut_copper": "Sliced copper",
  "block.minecraft.cut_copper_slab": "Slab o' sliced copper",
  "block.minecraft.cut_copper_stairs": "Stairs o' sliced copper",
  "block.minecraft.cut_red_sandstone": "Cut scarlet stone o' sands",
  "block.minecraft.cut_red_sandstone_slab": "Cut slab o' scarlet stone o' sands",
  "block.minecraft.cut_sandstone": "Cut stone o' sands",
  "block.minecraft.cut_sandstone_slab": "Cut slab o' stone o' sands",
  "block.minecraft.cyan_banner": "Ocean blue flag",
  "block.minecraft.cyan_bed": "Ocean blue bunk",
  "block.minecraft.cyan_candle": "Ocean blue glim",
  "block.minecraft.cyan_candle_cake": "Duff with ocean blue glim",
  "block.minecraft.cyan_carpet": "Ocean blue rug",
  "block.minecraft.cyan_concrete": "Ocean blue cement",
  "block.minecraft.cyan_concrete_powder": "Ocean blue cement dusts",
  "block.minecraft.cyan_glazed_terracotta": "Ocean blue pricey mosaic",
  "block.minecraft.cyan_shulker_box": "Ocean blue shulker box",
  "block.minecraft.cyan_stained_glass": "Ocean blue crystal",
  "block.minecraft.cyan_stained_glass_pane": "Ocean blue porthole",
  "block.minecraft.cyan_terracotta": "Ocean blue ancient clay",
  "block.minecraft.cyan_wool": "Ocean blue cloth",
  "block.minecraft.damaged_anvil": "Cracked slab o' fixin'",
  "block.minecraft.dandelion": "Yellow flower",
  "block.minecraft.dark_oak_button": "Knob o' dusky oak",
  "block.minecraft.dark_oak_door": "Door o' dusky oak",
  "block.minecraft.dark_oak_fence": "Picket o' dusky oak",
  "block.minecraft.dark_oak_fence_gate": "Picket gate o' dusky oak",
  "block.minecraft.dark_oak_hanging_sign": "Danglin' seal o' dusky oak",
  "block.minecraft.dark_oak_leaves": "Leaves o' dusky oak",
  "block.minecraft.dark_oak_log": "Log o' dusky oak",
  "block.minecraft.dark_oak_planks": "Planks o' dusky oak",
  "block.minecraft.dark_oak_pressure_plate": "Booby trap o' dusky oak",
  "block.minecraft.dark_oak_sapling": "Dusky oak meager shrub",
  "block.minecraft.dark_oak_shelf": "Rack o' dusky oak",
  "block.minecraft.dark_oak_sign": "Seal o' dusky oak",
  "block.minecraft.dark_oak_slab": "Slab o' dusky oak",
  "block.minecraft.dark_oak_stairs": "Stairs o' dusky oak",
  "block.minecraft.dark_oak_trapdoor": "Hatch o' dusky oak",
  "block.minecraft.dark_oak_wall_hanging_sign": "Danglin' wall seal o' dusky oak",
  "block.minecraft.dark_oak_wall_sign": "Wall seal o' dusky oak",
  "block.minecraft.dark_oak_wood": "Dusky oak timber",
  "block.minecraft.dark_prismarine": "Dusky prismarine",
  "block.minecraft.dark_prismarine_slab": "Slab o' dusky prismarine",
  "block.minecraft.dark_prismarine_stairs": "Stairs o' dusky prismarine",
  "block.minecraft.daylight_detector": "Sunrise finder",
  "block.minecraft.dead_brain_coral": "Dead walnut coral",
  "block.minecraft.dead_brain_coral_block": "Chunk o' dead walnut coral",
  "block.minecraft.dead_brain_coral_fan": "Dead walnut coral waf'r",
  "block.minecraft.dead_brain_coral_wall_fan": "Dead walnut coral wall waf'r",
  "block.minecraft.dead_bubble_coral": "Dead cyst coral",
  "block.minecraft.dead_bubble_coral_block": "Chunk o' dead cyst coral",
  "block.minecraft.dead_bubble_coral_fan": "Dead cyst coral waf'r",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dead cyst coral wall waf'r",
  "block.minecraft.dead_bush": "Unfortunate sight o' bush",
  "block.minecraft.dead_fire_coral": "Dead burnin' coral",
  "block.minecraft.dead_fire_coral_block": "Chunk o' dead burnin' coral",
  "block.minecraft.dead_fire_coral_fan": "Dead burnin' coral waf'r",
  "block.minecraft.dead_fire_coral_wall_fan": "Dead burnin' coral wall waf'r",
  "block.minecraft.dead_horn_coral": "Dead horn coral",
  "block.minecraft.dead_horn_coral_block": "Chunk o' dead horn coral",
  "block.minecraft.dead_horn_coral_fan": "Dead horn coral waf'r",
  "block.minecraft.dead_horn_coral_wall_fan": "Dead horn coral wall waf'r",
  "block.minecraft.dead_tube_coral": "Dead cylind'r o' coral",
  "block.minecraft.dead_tube_coral_block": "Chunk o' dead cylind'r coral",
  "block.minecraft.dead_tube_coral_fan": "Dead cylind'r coral waf'r",
  "block.minecraft.dead_tube_coral_wall_fan": "Dead cylind'r coral wall waf'r",
  "block.minecraft.decorated_pot": "Festooned dirt vase",
  "block.minecraft.deepslate": "Tough rock",
  "block.minecraft.deepslate_brick_slab": "Slab o' bricks o' tough rock",
  "block.minecraft.deepslate_brick_stairs": "Stairs o' bricks o' tough rock",
  "block.minecraft.deepslate_brick_wall": "Wall o' bricks o' tough rock",
  "block.minecraft.deepslate_bricks": "Bricks o' tough rock",
  "block.minecraft.deepslate_coal_ore": "Tough orrre o' fuel",
  "block.minecraft.deepslate_copper_ore": "Tough orrre o' copper",
  "block.minecraft.deepslate_diamond_ore": "Tough orrre o' diamond",
  "block.minecraft.deepslate_emerald_ore": "Tough orrre o' emerald",
  "block.minecraft.deepslate_gold_ore": "Tough orrre o' gold",
  "block.minecraft.deepslate_iron_ore": "Tough orrre o' steel",
  "block.minecraft.deepslate_lapis_ore": "Tough orrre o' lāzhward",
  "block.minecraft.deepslate_redstone_ore": "Tough orrre o' redstone",
  "block.minecraft.deepslate_tile_slab": "Slab o' tiles o' tough rock",
  "block.minecraft.deepslate_tile_stairs": "Stairs o' tiles o' tough rock",
  "block.minecraft.deepslate_tile_wall": "Wall o' tiles o' tough rock",
  "block.minecraft.deepslate_tiles": "Tiles o' tough rock",
  "block.minecraft.detector_rail": "Magic track",
  "block.minecraft.diamond_block": "Chunk o' diamond",
  "block.minecraft.diamond_ore": "Orrre o' diamond",
  "block.minecraft.diorite": "White pebbles",
  "block.minecraft.diorite_slab": "Slab o' white pebbles",
  "block.minecraft.diorite_stairs": "Stairs o' white pebbles",
  "block.minecraft.diorite_wall": "Wall o' white pebbles",
  "block.minecraft.dirt": "Filth",
  "block.minecraft.dirt_path": "Trodden path",
  "block.minecraft.dispenser": "Cannon",
  "block.minecraft.dragon_egg": "Wyvern's last treasure",
  "block.minecraft.dragon_head": "Wyvern skull",
  "block.minecraft.dragon_wall_head": "Wyvern wall skull",
  "block.minecraft.dried_ghast": "Dry ghast",
  "block.minecraft.dried_kelp_block": "Chunk o' dry sea lettuce",
  "block.minecraft.dripstone_block": "Chunk o' pointy rock",
  "block.minecraft.dropper": "Broken cannon",
  "block.minecraft.emerald_block": "Chunk o' emerald",
  "block.minecraft.emerald_ore": "Orrre o' emerald",
  "block.minecraft.enchanting_table": "Witchcraft bench",
  "block.minecraft.end_gateway": "Gateway o' th' End",
  "block.minecraft.end_portal": "Porthole to End",
  "block.minecraft.end_portal_frame": "End porthole holderrr",
  "block.minecraft.end_rod": "End wand",
  "block.minecraft.end_stone": "End stone",
  "block.minecraft.end_stone_brick_slab": "Slab o' bricks o' end stone",
  "block.minecraft.end_stone_brick_stairs": "Stairs o' bricks o' end stone",
  "block.minecraft.end_stone_brick_wall": "Wall o' bricks o' end stone",
  "block.minecraft.end_stone_bricks": "Bricks o' end stone",
  "block.minecraft.ender_chest": "Ender coffer",
  "block.minecraft.exposed_chiseled_copper": "Showin' carv'd copper",
  "block.minecraft.exposed_copper": "Showin' copper",
  "block.minecraft.exposed_copper_bars": "Barrrs o' showin' copper",
  "block.minecraft.exposed_copper_bulb": "Deck lanterrrn o' showin' copper",
  "block.minecraft.exposed_copper_chain": "Chain o' showin' copper",
  "block.minecraft.exposed_copper_chest": "Coffer o' showin' copper",
  "block.minecraft.exposed_copper_door": "Door o' showin' copper",
  "block.minecraft.exposed_copper_golem_statue": "Showin' statue o' copper matey",
  "block.minecraft.exposed_copper_grate": "Grate o' showin' copper",
  "block.minecraft.exposed_copper_lantern": "Lanterrrn showin' copper",
  "block.minecraft.exposed_copper_trapdoor": "Hatch o' showin' copper",
  "block.minecraft.exposed_cut_copper": "Showin' sliced copper",
  "block.minecraft.exposed_cut_copper_slab": "Slab o' showin' sliced copper",
  "block.minecraft.exposed_cut_copper_stairs": "Stairs o' showin' sliced copper",
  "block.minecraft.exposed_lightning_rod": "Showin' rod o' thunderstorms",
  "block.minecraft.farmland": "Fertile land",
  "block.minecraft.fern": "Jungle plant",
  "block.minecraft.fire": "Flames",
  "block.minecraft.fire_coral": "Burnin coral",
  "block.minecraft.fire_coral_block": "Chunk o' burnin coral",
  "block.minecraft.fire_coral_fan": "Burnin coral waf'r",
  "block.minecraft.fire_coral_wall_fan": "Burnin coral wall waf'r",
  "block.minecraft.firefly_bush": "Glowin' beetle shrub",
  "block.minecraft.fletching_table": "Stick sharp'n table",
  "block.minecraft.flower_pot": "Dirt vase",
  "block.minecraft.flowering_azalea": "Flowerin' azalea",
  "block.minecraft.flowering_azalea_leaves": "Leaves o' flowerin' azalea",
  "block.minecraft.frogspawn": "Froglets",
  "block.minecraft.frosted_ice": "Frosty frost",
  "block.minecraft.furnace": "Oven",
  "block.minecraft.gilded_blackstone": "Shiny rock o' black",
  "block.minecraft.glass": "Porthole",
  "block.minecraft.glass_pane": "Porthole",
  "block.minecraft.glow_lichen": "Glowin' algae",
  "block.minecraft.glowstone": "Glowstone",
  "block.minecraft.gold_block": "Chunk o' gold",
  "block.minecraft.gold_ore": "Orrre o' gold",
  "block.minecraft.golden_dandelion": "Golden flower",
  "block.minecraft.granite": "Brown pebbles",
  "block.minecraft.granite_slab": "Slab o' brown pebbles",
  "block.minecraft.granite_stairs": "Stairs o' brown pebbles",
  "block.minecraft.granite_wall": "Wall o' brown pebbles",
  "block.minecraft.grass": "Grass",
  "block.minecraft.grass_block": "Chunk o' grass",
  "block.minecraft.gravel": "Rubble",
  "block.minecraft.gray_banner": "Gray flag",
  "block.minecraft.gray_bed": "Gray bunk",
  "block.minecraft.gray_candle": "Gray glim",
  "block.minecraft.gray_candle_cake": "Duff with gray glim",
  "block.minecraft.gray_carpet": "Gray rug",
  "block.minecraft.gray_concrete": "Gray cement",
  "block.minecraft.gray_concrete_powder": "Gray cement dusts",
  "block.minecraft.gray_glazed_terracotta": "Gray pricey mosaic",
  "block.minecraft.gray_shulker_box": "Gray shulker box",
  "block.minecraft.gray_stained_glass": "Gray crystal",
  "block.minecraft.gray_stained_glass_pane": "Gray porthole",
  "block.minecraft.gray_terracotta": "Gray ancient clay",
  "block.minecraft.gray_wool": "Gray cloth",
  "block.minecraft.green_banner": "Green flag",
  "block.minecraft.green_bed": "Green bunk",
  "block.minecraft.green_candle": "Green glim",
  "block.minecraft.green_candle_cake": "Duff with green glim",
  "block.minecraft.green_carpet": "Green rug",
  "block.minecraft.green_concrete": "Green cement",
  "block.minecraft.green_concrete_powder": "Green cement dusts",
  "block.minecraft.green_glazed_terracotta": "Green pricey mosaic",
  "block.minecraft.green_shulker_box": "Green shulker box",
  "block.minecraft.green_stained_glass": "Green crystal",
  "block.minecraft.green_stained_glass_pane": "Green porthole",
  "block.minecraft.green_terracotta": "Green ancient clay",
  "block.minecraft.green_wool": "Green cloth",
  "block.minecraft.grindstone": "Smithin' rock",
  "block.minecraft.hanging_roots": "Hangin' roots",
  "block.minecraft.hay_block": "Bale o' hops",
  "block.minecraft.heavy_core": "Core o' heft",
  "block.minecraft.heavy_weighted_pressure_plate": "Booby trap o' heavy heft",
  "block.minecraft.honey_block": "Cube o' bee nectar",
  "block.minecraft.honeycomb_block": "Cube o' bee treasure",
  "block.minecraft.hopper": "Suckin' device",
  "block.minecraft.horn_coral": "Horn coral",
  "block.minecraft.horn_coral_block": "Chunk o' horn coral",
  "block.minecraft.horn_coral_fan": "Horn coral waf'r",
  "block.minecraft.horn_coral_wall_fan": "Horn coral wall waf'r",
  "block.minecraft.ice": "Frost",
  "block.minecraft.infested_chiseled_stone_bricks": "Inhabited carv'd bricks o' rock",
  "block.minecraft.infested_cobblestone": "Inhabited pebbles",
  "block.minecraft.infested_cracked_stone_bricks": "Inhabited cracked bricks o' rock",
  "block.minecraft.infested_deepslate": "Inhabited tough rock",
  "block.minecraft.infested_mossy_stone_bricks": "Inhabited slimy bricks o' rock",
  "block.minecraft.infested_stone": "Inhabited rock",
  "block.minecraft.infested_stone_bricks": "Inhabited bricks o' rock",
  "block.minecraft.iron_bars": "Barrrs o' steel",
  "block.minecraft.iron_block": "Chunk o' steel",
  "block.minecraft.iron_chain": "Chain o' steel",
  "block.minecraft.iron_door": "Door o' steel",
  "block.minecraft.iron_ore": "Orrre o' steel",
  "block.minecraft.iron_trapdoor": "Hatch o' steel",
  "block.minecraft.jack_o_lantern": "Jack o'lanterrrn",
  "block.minecraft.jigsaw": "Pieces o' eight block",
  "block.minecraft.jukebox": "Barrel organ",
  "block.minecraft.jungle_button": "Knob o' jungle",
  "block.minecraft.jungle_door": "Door o' jungle",
  "block.minecraft.jungle_fence": "Picket o' jungle",
  "block.minecraft.jungle_fence_gate": "Picket gate o' jungle",
  "block.minecraft.jungle_hanging_sign": "Danglin' seal o' jungle",
  "block.minecraft.jungle_leaves": "Leaves o' jungle",
  "block.minecraft.jungle_log": "Log o' jungle",
  "block.minecraft.jungle_planks": "Planks o' jungle",
  "block.minecraft.jungle_pressure_plate": "Booby trap o' jungle",
  "block.minecraft.jungle_sapling": "Jungle meager shrub",
  "block.minecraft.jungle_shelf": "Rack o' jungle",
  "block.minecraft.jungle_sign": "Seal o' jungle",
  "block.minecraft.jungle_slab": "Slab o' jungle",
  "block.minecraft.jungle_stairs": "Stairs o' jungle",
  "block.minecraft.jungle_trapdoor": "Hatch o' jungle",
  "block.minecraft.jungle_wall_hanging_sign": "Danglin' seal o' jungle",
  "block.minecraft.jungle_wall_sign": "Wall seal o' jungle",
  "block.minecraft.jungle_wood": "Jungle timber",
  "block.minecraft.kelp": "Sea lettuce",
  "block.minecraft.kelp_plant": "Sea lettuce seed",
  "block.minecraft.ladder": "Riggin'",
  "block.minecraft.lantern": "Lantarrrn",
  "block.minecraft.lapis_block": "Chunk o' lāzhward",
  "block.minecraft.lapis_ore": "Orrre o' lāzhward",
  "block.minecraft.large_amethyst_bud": "Huge bud o' gem",
  "block.minecraft.large_fern": "Whopper tree",
  "block.minecraft.lava": "Molten rock",
  "block.minecraft.lava_cauldron": "Pot o' molten rock",
  "block.minecraft.leaf_litter": "Pile o' leaves",
  "block.minecraft.lectern": "Readin' stand",
  "block.minecraft.lever": "Leverrr",
  "block.minecraft.light": "Shinin' ghost chunk",
  "block.minecraft.light_blue_banner": "Light blue flag",
  "block.minecraft.light_blue_bed": "Light blue bunk",
  "block.minecraft.light_blue_candle": "Light blue glim",
  "block.minecraft.light_blue_candle_cake": "Duff with light blue glim",
  "block.minecraft.light_blue_carpet": "Light blue rug",
  "block.minecraft.light_blue_concrete": "Light blue cement",
  "block.minecraft.light_blue_concrete_powder": "Light blue cement dusts",
  "block.minecraft.light_blue_glazed_terracotta": "Light blue pricey mosaic",
  "block.minecraft.light_blue_shulker_box": "Light blue shulker box",
  "block.minecraft.light_blue_stained_glass": "Light blue crystal",
  "block.minecraft.light_blue_stained_glass_pane": "Light blue porthole",
  "block.minecraft.light_blue_terracotta": "Light blue ancient clay",
  "block.minecraft.light_blue_wool": "Light blue cloth",
  "block.minecraft.light_gray_banner": "Light gray flag",
  "block.minecraft.light_gray_bed": "Light gray bunk",
  "block.minecraft.light_gray_candle": "Light gray glim",
  "block.minecraft.light_gray_candle_cake": "Duff with light gray glim",
  "block.minecraft.light_gray_carpet": "Light gray rug",
  "block.minecraft.light_gray_concrete": "Light gray cement",
  "block.minecraft.light_gray_concrete_powder": "Light gray cement dusts",
  "block.minecraft.light_gray_glazed_terracotta": "Light gray pricey mosaic",
  "block.minecraft.light_gray_shulker_box": "Light gray shulker box",
  "block.minecraft.light_gray_stained_glass": "Light gray crystal",
  "block.minecraft.light_gray_stained_glass_pane": "Light gray porthole",
  "block.minecraft.light_gray_terracotta": "Light gray ancient clay",
  "block.minecraft.light_gray_wool": "Light gray cloth",
  "block.minecraft.light_weighted_pressure_plate": "Booby trap o' light heft",
  "block.minecraft.lightning_rod": "Rod o' thunderstorms",
  "block.minecraft.lilac": "Ye lilac bouquet f' t' gals",
  "block.minecraft.lily_of_the_valley": "Pretty poison",
  "block.minecraft.lily_pad": "Pond plant",
  "block.minecraft.lime_banner": "Light green flag",
  "block.minecraft.lime_bed": "Light green bunk",
  "block.minecraft.lime_candle": "Light green glim",
  "block.minecraft.lime_candle_cake": "Duff with light green glim",
  "block.minecraft.lime_carpet": "Light green rug",
  "block.minecraft.lime_concrete": "Light green cement",
  "block.minecraft.lime_concrete_powder": "Light green cement dusts",
  "block.minecraft.lime_glazed_terracotta": "Light green pricey mosaic",
  "block.minecraft.lime_shulker_box": "Light green shulker box",
  "block.minecraft.lime_stained_glass": "Light green crystal",
  "block.minecraft.lime_stained_glass_pane": "Light green porthole",
  "block.minecraft.lime_terracotta": "Light green ancient clay",
  "block.minecraft.lime_wool": "Light green cloth",
  "block.minecraft.lodestone": "Wayfindin' rock",
  "block.minecraft.loom": "Sewin' station",
  "block.minecraft.magenta_banner": "Light purple flag",
  "block.minecraft.magenta_bed": "Light purple bunk",
  "block.minecraft.magenta_candle": "Light purple glim",
  "block.minecraft.magenta_candle_cake": "Duff with light purple glim",
  "block.minecraft.magenta_carpet": "Light purple rug",
  "block.minecraft.magenta_concrete": "Light purple cement",
  "block.minecraft.magenta_concrete_powder": "Light purple cement dusts",
  "block.minecraft.magenta_glazed_terracotta": "Light purple pricey mosaic",
  "block.minecraft.magenta_shulker_box": "Light purple shulker box",
  "block.minecraft.magenta_stained_glass": "Light purple crystal",
  "block.minecraft.magenta_stained_glass_pane": "Light purple porthole",
  "block.minecraft.magenta_terracotta": "Light purple ancient clay",
  "block.minecraft.magenta_wool": "Light purple cloth",
  "block.minecraft.magma_block": "Davy Jones' heat",
  "block.minecraft.mangrove_button": "Knob o' mangrove",
  "block.minecraft.mangrove_door": "Door o' mangrove",
  "block.minecraft.mangrove_fence": "Picket o' mangrove",
  "block.minecraft.mangrove_fence_gate": "Picket gate o' mangrove",
  "block.minecraft.mangrove_hanging_sign": "Danglin' seal o' mangrove",
  "block.minecraft.mangrove_leaves": "Leaves o' mangrove",
  "block.minecraft.mangrove_log": "Log o' mangrove",
  "block.minecraft.mangrove_planks": "Planks o' mangrove",
  "block.minecraft.mangrove_pressure_plate": "Booby trap o' mangrove",
  "block.minecraft.mangrove_propagule": "Lil' mangrove",
  "block.minecraft.mangrove_roots": "Roots o' mangrove",
  "block.minecraft.mangrove_shelf": "Rack o' mangrove",
  "block.minecraft.mangrove_sign": "Seal o' mangrove",
  "block.minecraft.mangrove_slab": "Slab o' mangrove",
  "block.minecraft.mangrove_stairs": "Stairs o' mangrove",
  "block.minecraft.mangrove_trapdoor": "Hatch o' mangrove",
  "block.minecraft.mangrove_wall_hanging_sign": "Danglin' wall seal o' mangrove",
  "block.minecraft.mangrove_wall_sign": "Wall seal o' mangrove",
  "block.minecraft.mangrove_wood": "Mangrove timber",
  "block.minecraft.medium_amethyst_bud": "Sizable bud o' gem",
  "block.minecraft.melon": "Watermel'n",
  "block.minecraft.melon_stem": "Twig o' melon",
  "block.minecraft.moss_block": "Chunk o' moss",
  "block.minecraft.moss_carpet": "Mossy rug",
  "block.minecraft.mossy_cobblestone": "Slimy pebbles",
  "block.minecraft.mossy_cobblestone_slab": "Slab o' slimy pebbles",
  "block.minecraft.mossy_cobblestone_stairs": "Stairs o' slimy pebbles",
  "block.minecraft.mossy_cobblestone_wall": "Wall o' slimy pebbles",
  "block.minecraft.mossy_stone_brick_slab": "Slab o' slimy bricks o' rock",
  "block.minecraft.mossy_stone_brick_stairs": "Stairs o' slimy bricks o' rock",
  "block.minecraft.mossy_stone_brick_wall": "Wall o' slimy bricks o' rock",
  "block.minecraft.mossy_stone_bricks": "Slimy bricks o' rock",
  "block.minecraft.moving_piston": "Movin' raised deck",
  "block.minecraft.mud": "Block o' mud",
  "block.minecraft.mud_brick_slab": "Brick slab o' clom",
  "block.minecraft.mud_brick_stairs": "Brick stairs o' clom",
  "block.minecraft.mud_brick_wall": "Brick wall o' clom",
  "block.minecraft.mud_bricks": "Bricks o' clom",
  "block.minecraft.muddy_mangrove_roots": "Dirty roots o' mangrove",
  "block.minecraft.mushroom_stem": "Twig o' shroom",
  "block.minecraft.mycelium": "Rottin' spores",
  "block.minecraft.nether_brick_fence": "Picket o' Nether",
  "block.minecraft.nether_brick_slab": "Slab o' brick o' Nether",
  "block.minecraft.nether_brick_stairs": "Stairs o' brick o' Nether",
  "block.minecraft.nether_brick_wall": "Wall o' bricks o' Nether",
  "block.minecraft.nether_bricks": "Bricks o' Nether",
  "block.minecraft.nether_gold_ore": "Nether orrre o' gold",
  "block.minecraft.nether_portal": "Porthole to Nether",
  "block.minecraft.nether_quartz_ore": "Orrre o' white rock",
  "block.minecraft.nether_sprouts": "Weeds o' Damnation",
  "block.minecraft.nether_wart": "Verruca o' Nether",
  "block.minecraft.nether_wart_block": "Chunk o' verruca",
  "block.minecraft.netherite_block": "Chunk o' Blackbeard's alloy",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Hornpipe",
  "block.minecraft.oak_button": "Knob o' oak",
  "block.minecraft.oak_door": "Door o' oak",
  "block.minecraft.oak_fence": "Picket o' oak",
  "block.minecraft.oak_fence_gate": "Picket gate o' oak",
  "block.minecraft.oak_hanging_sign": "Danglin' seal o' oak",
  "block.minecraft.oak_leaves": "Leaves o' oak",
  "block.minecraft.oak_log": "Log o' oak",
  "block.minecraft.oak_planks": "Planks o' oak",
  "block.minecraft.oak_pressure_plate": "Booby trap o' oak",
  "block.minecraft.oak_sapling": "Oak meager shrub",
  "block.minecraft.oak_shelf": "Rack o' oak",
  "block.minecraft.oak_sign": "Seal o' oak",
  "block.minecraft.oak_slab": "Slab o' oak",
  "block.minecraft.oak_stairs": "Stairs o' oak",
  "block.minecraft.oak_trapdoor": "Hatch o' oak",
  "block.minecraft.oak_wall_hanging_sign": "Danglin' wall seal o' oak",
  "block.minecraft.oak_wall_sign": "Wall seal o' oak",
  "block.minecraft.oak_wood": "Oak timber",
  "block.minecraft.observer": "Snooper",
  "block.minecraft.obsidian": "Rock o' tears",
  "block.minecraft.ochre_froglight": "Ochre light o' frog",
  "block.minecraft.ominous_banner": "Foul flag",
  "block.minecraft.open_eyeblossom": "Eye o' th' night be open",
  "block.minecraft.orange_banner": "Orange flag",
  "block.minecraft.orange_bed": "Orange bunk",
  "block.minecraft.orange_candle": "Orange glim",
  "block.minecraft.orange_candle_cake": "Duff with orange glim",
  "block.minecraft.orange_carpet": "Orange rug",
  "block.minecraft.orange_concrete": "Orange cement",
  "block.minecraft.orange_concrete_powder": "Orange cement dusts",
  "block.minecraft.orange_glazed_terracotta": "Orange pricey mosaic",
  "block.minecraft.orange_shulker_box": "Orange shulker box",
  "block.minecraft.orange_stained_glass": "Orange crystal",
  "block.minecraft.orange_stained_glass_pane": "Orange porthole",
  "block.minecraft.orange_terracotta": "Orange ancient clay",
  "block.minecraft.orange_tulip": "Orange tulip",
  "block.minecraft.orange_wool": "Orange cloth",
  "block.minecraft.oxeye_daisy": "Daisy flower",
  "block.minecraft.oxidized_chiseled_copper": "Rusty carv'd copper",
  "block.minecraft.oxidized_copper": "Rusty copper",
  "block.minecraft.oxidized_copper_bars": "Barrrs o' rusty copper",
  "block.minecraft.oxidized_copper_bulb": "Deck lanterrrn o' rusty copper",
  "block.minecraft.oxidized_copper_chain": "Chain o' rusty copper",
  "block.minecraft.oxidized_copper_chest": "Coffer o' rusty copper",
  "block.minecraft.oxidized_copper_door": "Door o' rusty copper",
  "block.minecraft.oxidized_copper_golem_statue": "Rusty statue o' copper matey",
  "block.minecraft.oxidized_copper_grate": "Grate o' rusty copper",
  "block.minecraft.oxidized_copper_lantern": "Lanterrrn o' rusty copper",
  "block.minecraft.oxidized_copper_trapdoor": "Hatch o' rusty copper",
  "block.minecraft.oxidized_cut_copper": "Rusty sliced copper",
  "block.minecraft.oxidized_cut_copper_slab": "Slab o' rusty sliced copper",
  "block.minecraft.oxidized_cut_copper_stairs": "Stairs o' rusty sliced copper",
  "block.minecraft.oxidized_lightning_rod": "Rusty rod o' thunderstorms",
  "block.minecraft.packed_ice": "Tough frost",
  "block.minecraft.packed_mud": "Clom",
  "block.minecraft.pale_hanging_moss": "Danglin' grey moss",
  "block.minecraft.pale_moss_block": "Chunk o' grey moss",
  "block.minecraft.pale_moss_carpet": "Grey mossy rug",
  "block.minecraft.pale_oak_button": "Knob o' wash'd out oak",
  "block.minecraft.pale_oak_door": "Door o' wash'd out oak",
  "block.minecraft.pale_oak_fence": "Picket o' wash'd out oak",
  "block.minecraft.pale_oak_fence_gate": "Picket gate o' wash'd out oak",
  "block.minecraft.pale_oak_hanging_sign": "Danglin' seal o' wash'd out oak",
  "block.minecraft.pale_oak_leaves": "Leaves o' wash'd out oak",
  "block.minecraft.pale_oak_log": "Log o' wash'd out oak",
  "block.minecraft.pale_oak_planks": "Planks o' wash'd out oak",
  "block.minecraft.pale_oak_pressure_plate": "Booby trap o' wash'd out oak",
  "block.minecraft.pale_oak_sapling": "Wash'd out oak meager shrub",
  "block.minecraft.pale_oak_shelf": "Rack o' wash'd out oak",
  "block.minecraft.pale_oak_sign": "Seal o' wash'd out oak",
  "block.minecraft.pale_oak_slab": "Slab o' wash'd out oak",
  "block.minecraft.pale_oak_stairs": "Stairs o' wash'd out oak",
  "block.minecraft.pale_oak_trapdoor": "Hatch o' wash'd out oak",
  "block.minecraft.pale_oak_wall_hanging_sign": "Danglin' wall seal o' wash'd out oak",
  "block.minecraft.pale_oak_wall_sign": "Wall seal o' wash'd out oak",
  "block.minecraft.pale_oak_wood": "Wood o' wash'd out oak",
  "block.minecraft.pearlescent_froglight": "Pearlescent light o' frog",
  "block.minecraft.peony": "Yer massive pink flower",
  "block.minecraft.petrified_oak_slab": "Slab o' petrified oak",
  "block.minecraft.piglin_head": "Piglin skull",
  "block.minecraft.piglin_wall_head": "Piglin wall skull",
  "block.minecraft.pink_banner": "Pink flag",
  "block.minecraft.pink_bed": "Pink bunk",
  "block.minecraft.pink_candle": "Pink glim",
  "block.minecraft.pink_candle_cake": "Duff with pink glim",
  "block.minecraft.pink_carpet": "Pink rug",
  "block.minecraft.pink_concrete": "Pink cement",
  "block.minecraft.pink_concrete_powder": "Pink cement dusts",
  "block.minecraft.pink_glazed_terracotta": "Pink pricey mosaic",
  "block.minecraft.pink_petals": "Pink flower leaves",
  "block.minecraft.pink_shulker_box": "Pink shulker box",
  "block.minecraft.pink_stained_glass": "Pink crystal",
  "block.minecraft.pink_stained_glass_pane": "Pink porthole",
  "block.minecraft.pink_terracotta": "Pink ancient clay",
  "block.minecraft.pink_tulip": "Pink tulip",
  "block.minecraft.pink_wool": "Pink cloth",
  "block.minecraft.piston": "Raised deck",
  "block.minecraft.piston_head": "Raised deck skull",
  "block.minecraft.pitcher_crop": "Crop o' barrrel plant",
  "block.minecraft.pitcher_plant": "Barrrel plant",
  "block.minecraft.player_head": "Sailor skull",
  "block.minecraft.player_head.named": "%s's skull",
  "block.minecraft.player_wall_head": "Sailor wall skull",
  "block.minecraft.podzol": "Pine straw",
  "block.minecraft.pointed_dripstone": "Sharp pointy rock",
  "block.minecraft.polished_andesite": "Good lookin' gray pebbles",
  "block.minecraft.polished_andesite_slab": "Slab o' good lookin' gray pebbles",
  "block.minecraft.polished_andesite_stairs": "Stairs o' good lookin' gray pebbles",
  "block.minecraft.polished_basalt": "Good lookin' rock o' magma",
  "block.minecraft.polished_blackstone": "Good lookin' rock o' black",
  "block.minecraft.polished_blackstone_brick_slab": "Good lookin' slab o' bricks o' rock o' black",
  "block.minecraft.polished_blackstone_brick_stairs": "Good lookin' stairs o' bricks o' rock o' black",
  "block.minecraft.polished_blackstone_brick_wall": "Good lookin' wall o' bricks o' rock o' black",
  "block.minecraft.polished_blackstone_bricks": "Good lookin' bricks o' rock o' black",
  "block.minecraft.polished_blackstone_button": "Knob o' good lookin' black rock",
  "block.minecraft.polished_blackstone_pressure_plate": "Booby trap o' good lookin' black rock",
  "block.minecraft.polished_blackstone_slab": "Slab o' good lookin' black rock",
  "block.minecraft.polished_blackstone_stairs": "Stairs o' good lookin' black rock",
  "block.minecraft.polished_blackstone_wall": "Wall o' good lookin' black rock",
  "block.minecraft.polished_deepslate": "Good lookin' tough rock",
  "block.minecraft.polished_deepslate_slab": "Slab o' good lookin' tough rock",
  "block.minecraft.polished_deepslate_stairs": "Stairs o' good lookin' tough rock",
  "block.minecraft.polished_deepslate_wall": "Wall o' good lookin' tough rock",
  "block.minecraft.polished_diorite": "Good lookin' white pebbles",
  "block.minecraft.polished_diorite_slab": "Slab o' good lookin' white pebbles",
  "block.minecraft.polished_diorite_stairs": "Stairs o' good lookin' white pebbles",
  "block.minecraft.polished_granite": "Good lookin' brown pebbles",
  "block.minecraft.polished_granite_slab": "Slab o' good lookin' brown pebbles",
  "block.minecraft.polished_granite_stairs": "Stairs o' good lookin' brown pebbles",
  "block.minecraft.polished_tuff": "Good lookin' rock o' ash",
  "block.minecraft.polished_tuff_slab": "Slab o' good lookin' rock o' ash",
  "block.minecraft.polished_tuff_stairs": "Stairs o' good lookin' rock o' ash",
  "block.minecraft.polished_tuff_wall": "Wall o' good lookin' rock o' ash",
  "block.minecraft.poppy": "Scarlet flower",
  "block.minecraft.potatoes": "Taters",
  "block.minecraft.potted_acacia_sapling": "Dirt vase o' acacia meager shrub",
  "block.minecraft.potted_allium": "Dirt vase o' pink fluff",
  "block.minecraft.potted_azalea_bush": "Dirt vase o' azalea",
  "block.minecraft.potted_azure_bluet": "Dirt vase o' blue flower",
  "block.minecraft.potted_bamboo": "Dirt vase o' bambarrr",
  "block.minecraft.potted_birch_sapling": "Dirt vase o' birch meager shrub",
  "block.minecraft.potted_blue_orchid": "Dirt vase o' beauty o' the swamps",
  "block.minecraft.potted_brown_mushroom": "Dirt vase o' brown shroom",
  "block.minecraft.potted_cactus": "Dirt vase o' cactus",
  "block.minecraft.potted_cherry_sapling": "Dirt vase o' cherry meager shrub",
  "block.minecraft.potted_closed_eyeblossom": "Dirt vase o' closed eye o' th' night",
  "block.minecraft.potted_cornflower": "Dirt vase o' cornflowarrr",
  "block.minecraft.potted_crimson_fungus": "Dirt vase o' fungus o' ichor",
  "block.minecraft.potted_crimson_roots": "Dirt vase o' tendrils o' ichor",
  "block.minecraft.potted_dandelion": "Dirt vase o' yellow flower",
  "block.minecraft.potted_dark_oak_sapling": "Dirt vase o' dusky oak meager shrub",
  "block.minecraft.potted_dead_bush": "Dirt vase o' unfortunate sight o' leaves",
  "block.minecraft.potted_fern": "Dirt vase o' jungle plant",
  "block.minecraft.potted_flowering_azalea_bush": "Dirt vase o' flowerin' azalea",
  "block.minecraft.potted_golden_dandelion": "Dirt vase o' golden flower",
  "block.minecraft.potted_jungle_sapling": "Dirt vase o' jungle meager shrub",
  "block.minecraft.potted_lily_of_the_valley": "Dirt vase o' pretty poison",
  "block.minecraft.potted_mangrove_propagule": "Dirt vase o' lil' mangrove",
  "block.minecraft.potted_oak_sapling": "Dirt vase o' oak meager shrub",
  "block.minecraft.potted_open_eyeblossom": "Dirt vase o' open eye o' th' night",
  "block.minecraft.potted_orange_tulip": "Dirt vase o' orange tulip",
  "block.minecraft.potted_oxeye_daisy": "Dirt vase o' daisy flower",
  "block.minecraft.potted_pale_oak_sapling": "Dirt vase o' wash'd out oak meager shrub",
  "block.minecraft.potted_pink_tulip": "Dirt vase o' pink tulip",
  "block.minecraft.potted_poppy": "Dirt vase o' scarlet flower",
  "block.minecraft.potted_red_mushroom": "Dirt vase o' scarlet shroom",
  "block.minecraft.potted_red_tulip": "Dirt vase o' scarlet tulip",
  "block.minecraft.potted_spruce_sapling": "Dirt vase o' spruce meager shrub",
  "block.minecraft.potted_torchflower": "Dirt vase o' torchflower",
  "block.minecraft.potted_warped_fungus": "Potted Fungus o' Twistin'",
  "block.minecraft.potted_warped_roots": "Potted Tendrils o' Twistin'",
  "block.minecraft.potted_white_tulip": "Dirt vase o' white tulip",
  "block.minecraft.potted_wither_rose": "Dirt vase o' wither blossom",
  "block.minecraft.powder_snow": "Snowier snow",
  "block.minecraft.powder_snow_cauldron": "Pot o' snowier snow",
  "block.minecraft.powered_rail": "Boost track",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Slab o' bricks o' prismarine",
  "block.minecraft.prismarine_brick_stairs": "Stairs o' bricks o' prismarine",
  "block.minecraft.prismarine_bricks": "Bricks o' prismarine",
  "block.minecraft.prismarine_slab": "Slab o' prismarine",
  "block.minecraft.prismarine_stairs": "Stairs o' prismarine",
  "block.minecraft.prismarine_wall": "Wall o' prismarine",
  "block.minecraft.pumpkin": "Gourd squash",
  "block.minecraft.pumpkin_stem": "Twig o' gourd squash",
  "block.minecraft.purple_banner": "Purple flag",
  "block.minecraft.purple_bed": "Purple bunk",
  "block.minecraft.purple_candle": "Purple glim",
  "block.minecraft.purple_candle_cake": "Duff with purple glim",
  "block.minecraft.purple_carpet": "Purple rug",
  "block.minecraft.purple_concrete": "Purple cement",
  "block.minecraft.purple_concrete_powder": "Purple cement dusts",
  "block.minecraft.purple_glazed_terracotta": "Purple pricey mosaic",
  "block.minecraft.purple_shulker_box": "Purple shulker box",
  "block.minecraft.purple_stained_glass": "Purple crystal",
  "block.minecraft.purple_stained_glass_pane": "Purple porthole",
  "block.minecraft.purple_terracotta": "Purple ancient clay",
  "block.minecraft.purple_wool": "Purple cloth",
  "block.minecraft.purpur_block": "Block o' purpur",
  "block.minecraft.purpur_pillar": "Post o' purpur",
  "block.minecraft.purpur_slab": "Slab o' purpur",
  "block.minecraft.purpur_stairs": "Stairs o' purpur",
  "block.minecraft.quartz_block": "Chunk o' white rock",
  "block.minecraft.quartz_bricks": "Bricks o' white rock",
  "block.minecraft.quartz_pillar": "Post o' white rock",
  "block.minecraft.quartz_slab": "Slab o' white rock",
  "block.minecraft.quartz_stairs": "Stairs o' white rock",
  "block.minecraft.rail": "Track",
  "block.minecraft.raw_copper_block": "Chunk o' rough copper",
  "block.minecraft.raw_gold_block": "Chunk o' rough gold",
  "block.minecraft.raw_iron_block": "Chunk o' rough steel",
  "block.minecraft.red_banner": "Scarlet flag",
  "block.minecraft.red_bed": "Scarlet bunk",
  "block.minecraft.red_candle": "Scarlet glim",
  "block.minecraft.red_candle_cake": "Duff with scarlet glim",
  "block.minecraft.red_carpet": "Scarlet rug",
  "block.minecraft.red_concrete": "Scarlet cement",
  "block.minecraft.red_concrete_powder": "Scarlet cement dusts",
  "block.minecraft.red_glazed_terracotta": "Scarlet pricey mosaic",
  "block.minecraft.red_mushroom": "Scarlet shroom",
  "block.minecraft.red_mushroom_block": "Chunk o' scarlet shroom",
  "block.minecraft.red_nether_brick_slab": "Slab o' scarlet bricks o' Nether",
  "block.minecraft.red_nether_brick_stairs": "Stairs o' scarlet bricks o' Nether",
  "block.minecraft.red_nether_brick_wall": "Wall o' scarlet bricks o' Nether",
  "block.minecraft.red_nether_bricks": "Scarlet bricks o' Nether",
  "block.minecraft.red_sand": "Scarlet sand",
  "block.minecraft.red_sandstone": "Scarlet stone o' sands",
  "block.minecraft.red_sandstone_slab": "Slab o' scarlet stone o' sands",
  "block.minecraft.red_sandstone_stairs": "Stairs o' scarlet stone o' sands",
  "block.minecraft.red_sandstone_wall": "Wall o' scarlet stone o' sands",
  "block.minecraft.red_shulker_box": "Scarlet shulker box",
  "block.minecraft.red_stained_glass": "Scarlet crystal",
  "block.minecraft.red_stained_glass_pane": "Scarlet porthole",
  "block.minecraft.red_terracotta": "Scarlet ancient clay",
  "block.minecraft.red_tulip": "Scarlet tulip",
  "block.minecraft.red_wool": "Scarlet cloth",
  "block.minecraft.redstone_block": "Chunk o' redstone",
  "block.minecraft.redstone_lamp": "Redstone lanterrrn",
  "block.minecraft.redstone_ore": "Orrre o' redstone",
  "block.minecraft.redstone_torch": "Redstone torch",
  "block.minecraft.redstone_wall_torch": "Redstone wall torch",
  "block.minecraft.redstone_wire": "Wire o' redstone",
  "block.minecraft.reinforced_deepslate": "Mighty tough rock",
  "block.minecraft.repeater": "Redstone repeatarrr",
  "block.minecraft.repeating_command_block": "Quick order block",
  "block.minecraft.resin_block": "Chunk o' treacle ooze",
  "block.minecraft.resin_brick_slab": "Brick slab o' treacle ooze",
  "block.minecraft.resin_brick_stairs": "Brick stairs o' treacle ooze",
  "block.minecraft.resin_brick_wall": "Brick wall o' treacle ooze",
  "block.minecraft.resin_bricks": "Bricks o' treacle ooze",
  "block.minecraft.resin_clump": "Pile o' treacle ooze",
  "block.minecraft.respawn_anchor": "Rebirthin' relic",
  "block.minecraft.rooted_dirt": "Filth o' roots",
  "block.minecraft.rose_bush": "Bush o' roses",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Stone o' sands",
  "block.minecraft.sandstone_slab": "Slab o' stone o' sands",
  "block.minecraft.sandstone_stairs": "Stairs o' stone o' sands",
  "block.minecraft.sandstone_wall": "Wall o' stone o' sands",
  "block.minecraft.scaffolding": "Shipbuildin' frame",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalyst o' sculk",
  "block.minecraft.sculk_sensor": "Sensor o' Silence",
  "block.minecraft.sculk_shrieker": "Screaming Sculk Base",
  "block.minecraft.sculk_vein": "Shrubs o' sculk",
  "block.minecraft.sea_lantern": "Light buoy",
  "block.minecraft.sea_pickle": "Salty sea pickle",
  "block.minecraft.seagrass": "Grass o' sea",
  "block.minecraft.set_spawn": "Dock point set",
  "block.minecraft.short_dry_grass": "Short dry grass",
  "block.minecraft.short_grass": "Short grass",
  "block.minecraft.shroomlight": "Spore o' Glowin'",
  "block.minecraft.shulker_box": "Shulker box",
  "block.minecraft.skeleton_skull": "Bag o' bones skull",
  "block.minecraft.skeleton_wall_skull": "Bag o' bones wall skull",
  "block.minecraft.slime_block": "Block o' slime",
  "block.minecraft.small_amethyst_bud": "Small bud o' purple gem",
  "block.minecraft.small_dripleaf": "Venus flytrap",
  "block.minecraft.smithing_table": "Forgin' bench",
  "block.minecraft.smoker": "Galley oven",
  "block.minecraft.smooth_basalt": "Smooth rock o' magma",
  "block.minecraft.smooth_quartz": "Chunk o' smooth white rock",
  "block.minecraft.smooth_quartz_slab": "Slab o' smooth white rock",
  "block.minecraft.smooth_quartz_stairs": "Stairs o' smooth white rock",
  "block.minecraft.smooth_red_sandstone": "Smooth scarlet sandstone o' sands",
  "block.minecraft.smooth_red_sandstone_slab": "Slab o' smooth scarlet stone o' sands",
  "block.minecraft.smooth_red_sandstone_stairs": "Stairs o' smooth scarlet stone o' sands",
  "block.minecraft.smooth_sandstone": "Smooth stone o' sands",
  "block.minecraft.smooth_sandstone_slab": "Slab o' smooth stone o' sands",
  "block.minecraft.smooth_sandstone_stairs": "Stairs o' smooth stone o' sands",
  "block.minecraft.smooth_stone": "Smooth rock",
  "block.minecraft.smooth_stone_slab": "Slab o' smooth rock",
  "block.minecraft.sniffer_egg": "Cackle fruit o' sniffin' beast",
  "block.minecraft.snow": "Slush",
  "block.minecraft.snow_block": "Chunk o' slush",
  "block.minecraft.soul_campfire": "Campfire o' agony",
  "block.minecraft.soul_fire": "Flames o' spirit",
  "block.minecraft.soul_lantern": "Spirit lantarrrn",
  "block.minecraft.soul_sand": "Sand o' the Devil",
  "block.minecraft.soul_soil": "Mud o' th' dead",
  "block.minecraft.soul_torch": "Spirit torch",
  "block.minecraft.soul_wall_torch": "Spirit wall torch",
  "block.minecraft.spawn.not_valid": "Yer 'ave no 'ome bed or rebirthen' relic, or it be destroyed at sea",
  "block.minecraft.spawner": "Creator o' beasts",
  "block.minecraft.spawner.desc1": "Engage wit' cackle fruit:",
  "block.minecraft.spawner.desc2": "Sets creature type",
  "block.minecraft.sponge": "Sponge",
  "block.minecraft.spore_blossom": "Spore flower o' caves",
  "block.minecraft.spruce_button": "Knob o' spruce",
  "block.minecraft.spruce_door": "Door o' spruce",
  "block.minecraft.spruce_fence": "Picket o' spruce",
  "block.minecraft.spruce_fence_gate": "Picket gate o' spruce",
  "block.minecraft.spruce_hanging_sign": "Danglin' seal o' spruce",
  "block.minecraft.spruce_leaves": "Leaves o' spruce",
  "block.minecraft.spruce_log": "Log o' spruce",
  "block.minecraft.spruce_planks": "Planks o' spruce",
  "block.minecraft.spruce_pressure_plate": "Booby trap o' spruce",
  "block.minecraft.spruce_sapling": "Spruce meager shrub",
  "block.minecraft.spruce_shelf": "Rack o' spruce",
  "block.minecraft.spruce_sign": "Seal o' spruce",
  "block.minecraft.spruce_slab": "Slab o' spruce",
  "block.minecraft.spruce_stairs": "Stairs o' spruce",
  "block.minecraft.spruce_trapdoor": "Hatch o' spruce",
  "block.minecraft.spruce_wall_hanging_sign": "Danglin' wall seal o' spruce",
  "block.minecraft.spruce_wall_sign": "Wall seal o' spruce",
  "block.minecraft.spruce_wood": "Spruce timber",
  "block.minecraft.sticky_piston": "Sticky raised deck",
  "block.minecraft.stone": "Rock",
  "block.minecraft.stone_brick_slab": "Slab o' bricks o' rock",
  "block.minecraft.stone_brick_stairs": "Stairs o' bricks o' rock",
  "block.minecraft.stone_brick_wall": "Wall o' bricks o' rock",
  "block.minecraft.stone_bricks": "Bricks o' rock",
  "block.minecraft.stone_button": "Knob o' rock",
  "block.minecraft.stone_pressure_plate": "Booby trap o' rock",
  "block.minecraft.stone_slab": "Slab o' rock",
  "block.minecraft.stone_stairs": "Stairs o' rock",
  "block.minecraft.stonecutter": "Pebble chopp'r",
  "block.minecraft.stripped_acacia_log": "Bare log o' acacia",
  "block.minecraft.stripped_acacia_wood": "Bare acacia timber",
  "block.minecraft.stripped_bamboo_block": "Bare block o' bambarrr",
  "block.minecraft.stripped_birch_log": "Bare log o' birch",
  "block.minecraft.stripped_birch_wood": "Bare birch timber",
  "block.minecraft.stripped_cherry_log": "Bare log o' cherry",
  "block.minecraft.stripped_cherry_wood": "Bare wood o' cherry",
  "block.minecraft.stripped_crimson_hyphae": "Bare blood hyphae",
  "block.minecraft.stripped_crimson_stem": "Bare stem o' ichor",
  "block.minecraft.stripped_dark_oak_log": "Bare log o' dusky oak",
  "block.minecraft.stripped_dark_oak_wood": "Bare dusky oak timber",
  "block.minecraft.stripped_jungle_log": "Bare log o' jungle",
  "block.minecraft.stripped_jungle_wood": "Bare jungle timber",
  "block.minecraft.stripped_mangrove_log": "Bare log o' mangrove",
  "block.minecraft.stripped_mangrove_wood": "Bare wood o' mangrove",
  "block.minecraft.stripped_oak_log": "Bare log o' oak",
  "block.minecraft.stripped_oak_wood": "Bare oak timber",
  "block.minecraft.stripped_pale_oak_log": "Bare log o' wash'd out oak",
  "block.minecraft.stripped_pale_oak_wood": "Bare wash'd out oak",
  "block.minecraft.stripped_spruce_log": "Bare log o' spruce",
  "block.minecraft.stripped_spruce_wood": "Bare spruce timber",
  "block.minecraft.stripped_warped_hyphae": "Bare twisted hyphae",
  "block.minecraft.stripped_warped_stem": "Bare twisted stem o' hyphae",
  "block.minecraft.structure_block": "Ship sav'r",
  "block.minecraft.structure_void": "Nothin' here, lads",
  "block.minecraft.sugar_cane": "Sugar reed",
  "block.minecraft.sunflower": "Sunflower",
  "block.minecraft.suspicious_gravel": "Suspicious rubble",
  "block.minecraft.suspicious_sand": "Suspicious sand",
  "block.minecraft.sweet_berry_bush": "Land caper shrub",
  "block.minecraft.tall_dry_grass": "Tall dry grass",
  "block.minecraft.tall_grass": "Mighty grass",
  "block.minecraft.tall_seagrass": "Mighty grass o' sea",
  "block.minecraft.target": "Dartboard",
  "block.minecraft.terracotta": "Ancient clay",
  "block.minecraft.test_block": "Block o' testin'",
  "block.minecraft.test_instance_block": "Test instance block",
  "block.minecraft.tinted_glass": "Unwashed porthole",
  "block.minecraft.tnt": "Powder keg",
  "block.minecraft.tnt.disabled": "Explosions o' powder keg be disabled",
  "block.minecraft.torch": "Torch",
  "block.minecraft.torchflower": "Torchflower",
  "block.minecraft.torchflower_crop": "Harvest o' torchflower",
  "block.minecraft.trapped_chest": "Trapped coffer",
  "block.minecraft.trial_spawner": "Trial creator o' beasts",
  "block.minecraft.tripwire": "Dirty ol' boot tripper",
  "block.minecraft.tripwire_hook": "Trippin' thread hook",
  "block.minecraft.tube_coral": "Cylind'r coral",
  "block.minecraft.tube_coral_block": "Chunk o' cylind'r coral",
  "block.minecraft.tube_coral_fan": "Cylind'r coral waf'r",
  "block.minecraft.tube_coral_wall_fan": "Cylind'r coral wall waf'r",
  "block.minecraft.tuff": "Rock o' ash",
  "block.minecraft.tuff_brick_slab": "Slab o' bricks o' rock o' ash",
  "block.minecraft.tuff_brick_stairs": "Stairs o' bricks o' rock o' ash",
  "block.minecraft.tuff_brick_wall": "Wall o' bricks o' rock o' ash",
  "block.minecraft.tuff_bricks": "Bricks o' rock o' ash",
  "block.minecraft.tuff_slab": "Slab o' rock o' ash",
  "block.minecraft.tuff_stairs": "Stairs o' rock o' ash",
  "block.minecraft.tuff_wall": "Wall o' rock o' ash",
  "block.minecraft.turtle_egg": "Turtle cackle fruit",
  "block.minecraft.twisting_vines": "Twisted swingers",
  "block.minecraft.twisting_vines_plant": "Twisted swingers plant",
  "block.minecraft.vault": "Mighty coffer",
  "block.minecraft.verdant_froglight": "Verdant light o' frog",
  "block.minecraft.vine": "Swingers",
  "block.minecraft.void_air": "Davy Jones' breath",
  "block.minecraft.wall_torch": "Wall torch",
  "block.minecraft.warped_button": "Twisted knob o' hyphae",
  "block.minecraft.warped_door": "Twisted door o' hyphae",
  "block.minecraft.warped_fence": "Twisted picket o' hyphae",
  "block.minecraft.warped_fence_gate": "Twisted picket gate o' hyphae",
  "block.minecraft.warped_fungus": "Twisted fungus",
  "block.minecraft.warped_hanging_sign": "Twisted danglin seal o' hyphae",
  "block.minecraft.warped_hyphae": "Twisted strings",
  "block.minecraft.warped_nylium": "Twisted moss o' hyphae",
  "block.minecraft.warped_planks": "Twisted planks o' hyphae",
  "block.minecraft.warped_pressure_plate": "Twisted booby trap o' hyphae",
  "block.minecraft.warped_roots": "Twisted roots o' hyphae",
  "block.minecraft.warped_shelf": "Twisted rack",
  "block.minecraft.warped_sign": "Seal o' twistin'",
  "block.minecraft.warped_slab": "Twisted slab o' hyphae",
  "block.minecraft.warped_stairs": "Twisted stairs o' hyphae",
  "block.minecraft.warped_stem": "Twisted stem o' hyphae",
  "block.minecraft.warped_trapdoor": "Twisted hatch o' hyphae",
  "block.minecraft.warped_wall_hanging_sign": "Twisted danglin' wall seal o' hyphae",
  "block.minecraft.warped_wall_sign": "Twisted wall seal o' hyphae",
  "block.minecraft.warped_wart_block": "Blue 'Shroom o' Doom",
  "block.minecraft.water": "Bilge",
  "block.minecraft.water_cauldron": "Pot o' bilge",
  "block.minecraft.waxed_chiseled_copper": "Glazed carv'd copper",
  "block.minecraft.waxed_copper_bars": "Barrrs o' glazed copper",
  "block.minecraft.waxed_copper_block": "Chunk o' glazed copper",
  "block.minecraft.waxed_copper_bulb": "Deck lanterrrn o' glazed copper",
  "block.minecraft.waxed_copper_chain": "Chain o' glazed copper",
  "block.minecraft.waxed_copper_chest": "Chest o' glazed copper",
  "block.minecraft.waxed_copper_door": "Door o' glazed copper",
  "block.minecraft.waxed_copper_golem_statue": "Glazed statue o' copper matey",
  "block.minecraft.waxed_copper_grate": "Grate o' glazed copper",
  "block.minecraft.waxed_copper_lantern": "Lanterrrn glazed copper",
  "block.minecraft.waxed_copper_trapdoor": "Hatch o' glazed copper",
  "block.minecraft.waxed_cut_copper": "Glazed sliced copper",
  "block.minecraft.waxed_cut_copper_slab": "Slab o' glazed sliced copper",
  "block.minecraft.waxed_cut_copper_stairs": "Stairs o' glazed sliced copper",
  "block.minecraft.waxed_exposed_chiseled_copper": "Glazed showin' carv'd copper",
  "block.minecraft.waxed_exposed_copper": "Glazed showin' copper",
  "block.minecraft.waxed_exposed_copper_bars": "Barrrs o' glazed showin' copper",
  "block.minecraft.waxed_exposed_copper_bulb": "Deck lanterrrn o' glazed showin' copper",
  "block.minecraft.waxed_exposed_copper_chain": "Chain o' glazed showin' copper",
  "block.minecraft.waxed_exposed_copper_chest": "Coffer o' glazed showin' copper",
  "block.minecraft.waxed_exposed_copper_door": "Door o' glazed showin' copper",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Glazed showin' statue o' copper matey",
  "block.minecraft.waxed_exposed_copper_grate": "Grate o' glazed showin' copper",
  "block.minecraft.waxed_exposed_copper_lantern": "Lanterrrn o' glazed showin' copper",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Hatch o' glazed showin' copper",
  "block.minecraft.waxed_exposed_cut_copper": "Glazed showin' sliced copper",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Slab o' glazed showin' sliced copper",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Stairs o' glazed showin' sliced copper",
  "block.minecraft.waxed_exposed_lightning_rod": "Glazed showin' rod o' thunderstorms",
  "block.minecraft.waxed_lightning_rod": "Glazed rod o' thunderstorms",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Glazed rusty carv'd copper",
  "block.minecraft.waxed_oxidized_copper": "Glazed rusty copper",
  "block.minecraft.waxed_oxidized_copper_bars": "Barrrs o' glazed rusty copper",
  "block.minecraft.waxed_oxidized_copper_bulb": "Deck lanterrrn o' glazed rusty copper",
  "block.minecraft.waxed_oxidized_copper_chain": "Chain o' glazed rusty copper",
  "block.minecraft.waxed_oxidized_copper_chest": "Anti-Moss Rusty Chest o' Copper",
  "block.minecraft.waxed_oxidized_copper_door": "Door o' glazed rusty copper",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Glazed rusty statue o' copper matey",
  "block.minecraft.waxed_oxidized_copper_grate": "Grate o' glazed rusty copper",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lanterrrn o' glazed rusty copper",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Hatch o' glazed rusty copper",
  "block.minecraft.waxed_oxidized_cut_copper": "Glazed rusty sliced copper",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Slab o' glazed rusty sliced copper",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Stairs o' glazed rusty sliced copper",
  "block.minecraft.waxed_oxidized_lightning_rod": "Glazed rusty rod o' thunderstorms",
  "block.minecraft.waxed_weathered_chiseled_copper": "Glazed weathered carv'd copper",
  "block.minecraft.waxed_weathered_copper": "Glazed weathered copper",
  "block.minecraft.waxed_weathered_copper_bars": "Barrrs o' glazed weathered copper",
  "block.minecraft.waxed_weathered_copper_bulb": "Deck lanterrrn o' glazed weathered copper",
  "block.minecraft.waxed_weathered_copper_chain": "Chain o' glazed weathered copper",
  "block.minecraft.waxed_weathered_copper_chest": "Coffer o' glazed weathered copper",
  "block.minecraft.waxed_weathered_copper_door": "Door o' glazed weathered copper",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Glazed weathered statue o' copper matey",
  "block.minecraft.waxed_weathered_copper_grate": "Grate o' glazed weathered copper",
  "block.minecraft.waxed_weathered_copper_lantern": "Lanterrrn o' glazed weathered copper",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Hatch o' glazed weathered copper",
  "block.minecraft.waxed_weathered_cut_copper": "Glazed weathered sliced copper",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Slab o' glazed weathered sliced copper",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Stairs o' glazed weathered sliced copper",
  "block.minecraft.waxed_weathered_lightning_rod": "Glazed weathered rod o' thunderstorms",
  "block.minecraft.weathered_chiseled_copper": "Weathered carv'd copper",
  "block.minecraft.weathered_copper": "Weathered copper",
  "block.minecraft.weathered_copper_bars": "Barrrs o' weathered copper",
  "block.minecraft.weathered_copper_bulb": "Deck lanterrrn o' weathered copper",
  "block.minecraft.weathered_copper_chain": "Chain o' weathered copper",
  "block.minecraft.weathered_copper_chest": "Weathered coffer o' copper",
  "block.minecraft.weathered_copper_door": "Door o' weathered copper",
  "block.minecraft.weathered_copper_golem_statue": "Weathered statue o' copper matey",
  "block.minecraft.weathered_copper_grate": "Grate o' weathered copper",
  "block.minecraft.weathered_copper_lantern": "Lanterrrn o' weathered copper",
  "block.minecraft.weathered_copper_trapdoor": "Hatch o' weathered copper",
  "block.minecraft.weathered_cut_copper": "Weathered sliced copper",
  "block.minecraft.weathered_cut_copper_slab": "Slab o' weathered sliced copper",
  "block.minecraft.weathered_cut_copper_stairs": "Stairs o' weathered sliced copper",
  "block.minecraft.weathered_lightning_rod": "Weathered rod o' thunderstorms",
  "block.minecraft.weeping_vines": "Green String o' Sobbin'",
  "block.minecraft.weeping_vines_plant": "Sobbin' swingers plant",
  "block.minecraft.wet_sponge": "Watery sponge",
  "block.minecraft.wheat": "Wheat harvest",
  "block.minecraft.white_banner": "White flag",
  "block.minecraft.white_bed": "White bunk",
  "block.minecraft.white_candle": "White glim",
  "block.minecraft.white_candle_cake": "Duff with white glim",
  "block.minecraft.white_carpet": "White rug",
  "block.minecraft.white_concrete": "White cement",
  "block.minecraft.white_concrete_powder": "White cement dusts",
  "block.minecraft.white_glazed_terracotta": "White pricey mosaic",
  "block.minecraft.white_shulker_box": "White shulker box",
  "block.minecraft.white_stained_glass": "White crystal",
  "block.minecraft.white_stained_glass_pane": "White porthole",
  "block.minecraft.white_terracotta": "White ancient clay",
  "block.minecraft.white_tulip": "White tulip",
  "block.minecraft.white_wool": "White cloth",
  "block.minecraft.wildflowers": "Flowers fer th' ladies",
  "block.minecraft.wither_rose": "Wither blossom",
  "block.minecraft.wither_skeleton_skull": "Wither bag o' bones skull",
  "block.minecraft.wither_skeleton_wall_skull": "Wither bag o' bones wall skull",
  "block.minecraft.yellow_banner": "Yellow flag",
  "block.minecraft.yellow_bed": "Yellow bunk",
  "block.minecraft.yellow_candle": "Yellow glim",
  "block.minecraft.yellow_candle_cake": "Duff with yellow glim",
  "block.minecraft.yellow_carpet": "Yellow rug",
  "block.minecraft.yellow_concrete": "Yellow cement",
  "block.minecraft.yellow_concrete_powder": "Yellow cement dusts",
  "block.minecraft.yellow_glazed_terracotta": "Yellow pricey mosaic",
  "block.minecraft.yellow_shulker_box": "Yellow shulker box",
  "block.minecraft.yellow_stained_glass": "Yellow crystal",
  "block.minecraft.yellow_stained_glass_pane": "Yellow porthole",
  "block.minecraft.yellow_terracotta": "Yellow ancient clay",
  "block.minecraft.yellow_wool": "Yellow cloth",
  "block.minecraft.zombie_head": "Undead sailor skull",
  "block.minecraft.zombie_wall_head": "Undead sailor wall skull",
  "item.minecraft.acacia_boat": "Vessel o' acacia",
  "item.minecraft.acacia_chest_boat": "Vessel o' acacia wit' coffer",
  "item.minecraft.allay_spawn_egg": "Pixie cackle fruit",
  "item.minecraft.amethyst_shard": "Shard o' gem",
  "item.minecraft.angler_pottery_shard": "Fisherman's shard o' vase",
  "item.minecraft.angler_pottery_sherd": "Fisherman's clay fragment",
  "item.minecraft.apple": "Scurvy's cure",
  "item.minecraft.archer_pottery_shard": "Bowman's shard o' vase",
  "item.minecraft.archer_pottery_sherd": "Bowman's clay fragment",
  "item.minecraft.armadillo_scute": "Piece o' shellback matey",
  "item.minecraft.armadillo_spawn_egg": "Shellback matey cackle fruit",
  "item.minecraft.armor_stand": "Booty rack",
  "item.minecraft.arms_up_pottery_shard": "Arms to th' sky shard o' vase",
  "item.minecraft.arms_up_pottery_sherd": "Arms to th' sky clay fragment",
  "item.minecraft.arrow": "Bolt",
  "item.minecraft.axolotl_bucket": "Pail o' sea lizard",
  "item.minecraft.axolotl_spawn_egg": "Sea lizard cackle fruit",
  "item.minecraft.baked_potato": "Baked tater",
  "item.minecraft.bamboo_chest_raft": "Puny vessel o' bambarrr wit' coffer",
  "item.minecraft.bamboo_raft": "Puny vessel o' bambarrr",
  "item.minecraft.bat_spawn_egg": "Flyin' mouse cackle fruit",
  "item.minecraft.bee_spawn_egg": "Bee cackle fruit",
  "item.minecraft.beef": "Raw beef",
  "item.minecraft.beetroot": "Bloody tater",
  "item.minecraft.beetroot_seeds": "Seeds o' bloody taters",
  "item.minecraft.beetroot_soup": "Soup o' bloody taters",
  "item.minecraft.birch_boat": "Vessel o' birch",
  "item.minecraft.birch_chest_boat": "Vessel o' birch wit' coffer",
  "item.minecraft.black_bundle": "Black pouch",
  "item.minecraft.black_dye": "Dye o' black",
  "item.minecraft.black_harness": "Black harness",
  "item.minecraft.blade_pottery_shard": "Cutlass shard o' vase",
  "item.minecraft.blade_pottery_sherd": "Cutlass clay fragment",
  "item.minecraft.blaze_powder": "Blisterin' blaze powder",
  "item.minecraft.blaze_rod": "Burnin' stick",
  "item.minecraft.blaze_spawn_egg": "Blisterin' blaze cackle fruit",
  "item.minecraft.blue_bundle": "Blue pouch",
  "item.minecraft.blue_dye": "Dye o' blue",
  "item.minecraft.blue_egg": "Blue cackle fruit",
  "item.minecraft.blue_harness": "Blue harness",
  "item.minecraft.bogged_spawn_egg": "Slimey bag o' bones cackle fruit",
  "item.minecraft.bolt_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt cut o' armor",
  "item.minecraft.bone": "Bone",
  "item.minecraft.bone_meal": "Mashed bones",
  "item.minecraft.book": "Logbook",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure indented flag pattern",
  "item.minecraft.bow": "Flintlock",
  "item.minecraft.bowl": "Bowl",
  "item.minecraft.bread": "Hard tack",
  "item.minecraft.breeze_rod": "Zephyr's stick",
  "item.minecraft.breeze_spawn_egg": "Zephyr cackle fruit",
  "item.minecraft.brewer_pottery_shard": "Bottle o' rum shard o' vase",
  "item.minecraft.brewer_pottery_sherd": "Bottle o' rum clay fragment",
  "item.minecraft.brewing_stand": "Mixin' station",
  "item.minecraft.brick": "Brick o' clay",
  "item.minecraft.brown_bundle": "Brown pouch",
  "item.minecraft.brown_dye": "Dye o' brown",
  "item.minecraft.brown_egg": "Brown cackle fruit",
  "item.minecraft.brown_harness": "Brown harness",
  "item.minecraft.brush": "Brush",
  "item.minecraft.bucket": "Pail",
  "item.minecraft.bundle": "Pouch",
  "item.minecraft.bundle.empty": "Nothin' here",
  "item.minecraft.bundle.empty.description": "Holds mixed amounts o' booty",
  "item.minecraft.bundle.full": "Full of loot",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Fire on deck shard o' vase",
  "item.minecraft.burn_pottery_sherd": "Fire on deck clay fragment",
  "item.minecraft.camel_husk_spawn_egg": "Heated sand horse cackle fruit",
  "item.minecraft.camel_spawn_egg": "Sand horse cackle fruit",
  "item.minecraft.carrot": "Orange veggy",
  "item.minecraft.carrot_on_a_stick": "Stick o' orange veggy",
  "item.minecraft.cat_spawn_egg": "Parrot killer cackle fruit",
  "item.minecraft.cauldron": "Pot",
  "item.minecraft.cave_spider_spawn_egg": "Cave horror cackle fruit",
  "item.minecraft.chainmail_boots": "Peg-leg o' metal links",
  "item.minecraft.chainmail_chestplate": "Chestplate o' metal links",
  "item.minecraft.chainmail_helmet": "Helmet o' metal links",
  "item.minecraft.chainmail_leggings": "Greaves o' metal links",
  "item.minecraft.charcoal": "Burnt timber",
  "item.minecraft.cherry_boat": "Vessel o' cherry",
  "item.minecraft.cherry_chest_boat": "Vessel o' cherry wit' coffer",
  "item.minecraft.chest_minecart": "Coffer in a landlubbers' boat",
  "item.minecraft.chicken": "Raw fowl",
  "item.minecraft.chicken_spawn_egg": "Fowl cackle fruit",
  "item.minecraft.chorus_fruit": "Tall one's fruit",
  "item.minecraft.clay_ball": "Ball o' solid mud",
  "item.minecraft.clock": "Hourglass",
  "item.minecraft.coal": "Fuel",
  "item.minecraft.coast_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast cut o' armor",
  "item.minecraft.cocoa_beans": "Beans o' cacao",
  "item.minecraft.cod": "Raw codfish",
  "item.minecraft.cod_bucket": "Pail o' codfish",
  "item.minecraft.cod_spawn_egg": "Codfish cackle fruit",
  "item.minecraft.command_block_minecart": "Order block in a landlubbers' boat",
  "item.minecraft.compass": "Sextant",
  "item.minecraft.cooked_beef": "Steak",
  "item.minecraft.cooked_chicken": "Cooked fowl",
  "item.minecraft.cooked_cod": "Smoked codfish",
  "item.minecraft.cooked_mutton": "Cooked meat o' sheep",
  "item.minecraft.cooked_porkchop": "Cooked pigmeat",
  "item.minecraft.cooked_rabbit": "Cooked rabbit",
  "item.minecraft.cooked_salmon": "Smoked salmon",
  "item.minecraft.cookie": "Biscuit",
  "item.minecraft.copper_axe": "Hatchet o' copper",
  "item.minecraft.copper_boots": "Peg-leg o' copper",
  "item.minecraft.copper_chestplate": "Chestplate o' copper",
  "item.minecraft.copper_golem_spawn_egg": "Copper matey cackle fruit",
  "item.minecraft.copper_helmet": "Helmet o' copper",
  "item.minecraft.copper_hoe": "Farmin' stick o' copper",
  "item.minecraft.copper_horse_armor": "Brumby armor o' copper",
  "item.minecraft.copper_ingot": "Bullion o' copper",
  "item.minecraft.copper_leggings": "Greaves o' copper",
  "item.minecraft.copper_nautilus_armor": "Sea beast's clothin' o' copper",
  "item.minecraft.copper_nugget": "Doubloon o' copper",
  "item.minecraft.copper_pickaxe": "Pickaxe o' copper",
  "item.minecraft.copper_shovel": "Spade o' copper",
  "item.minecraft.copper_spear": "Harpoon o' copper",
  "item.minecraft.copper_sword": "Cutlass o' copper",
  "item.minecraft.cow_spawn_egg": "Bovine cackle fruit",
  "item.minecraft.creaking_spawn_egg": "Creakin’ wraithwood cackle fruit",
  "item.minecraft.creeper_banner_pattern": "Flag pattern",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper charge",
  "item.minecraft.creeper_banner_pattern.new": "Creeper charge flag pattern",
  "item.minecraft.creeper_spawn_egg": "Creeper cackle fruit",
  "item.minecraft.crossbow": "Crossbow",
  "item.minecraft.crossbow.projectile": "Blunderbuss:",
  "item.minecraft.crossbow.projectile.multiple": "Blunderbuss: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Blunderbuss: %s",
  "item.minecraft.cyan_bundle": "Ocean blue pouch",
  "item.minecraft.cyan_dye": "Dye o' ocean blue",
  "item.minecraft.cyan_harness": "Ocean harness",
  "item.minecraft.danger_pottery_shard": "Perilous shard o' vase",
  "item.minecraft.danger_pottery_sherd": "Perilous clay fragment",
  "item.minecraft.dark_oak_boat": "Vessel o' dusky oak",
  "item.minecraft.dark_oak_chest_boat": "Vessel o' dusky oak wit' coffer",
  "item.minecraft.debug_stick": "Debug stick",
  "item.minecraft.debug_stick.empty": "%s has no properties",
  "item.minecraft.debug_stick.select": "selected \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" to %s",
  "item.minecraft.diamond": "Diamond",
  "item.minecraft.diamond_axe": "Hatchet o' diamond",
  "item.minecraft.diamond_boots": "Peg-leg o' diamond",
  "item.minecraft.diamond_chestplate": "Chestplate o' diamond",
  "item.minecraft.diamond_helmet": "Helmet o' diamond",
  "item.minecraft.diamond_hoe": "Farmin' stick o' diamond",
  "item.minecraft.diamond_horse_armor": "Bejeweled brumby armor",
  "item.minecraft.diamond_leggings": "Greaves o' diamond",
  "item.minecraft.diamond_nautilus_armor": "Sea beast's clothin' o' diamond",
  "item.minecraft.diamond_pickaxe": "Pickaxe o' diamond",
  "item.minecraft.diamond_shovel": "Spade o' diamond",
  "item.minecraft.diamond_spear": "Harpoon o' diamond",
  "item.minecraft.diamond_sword": "Cutlass o' diamond",
  "item.minecraft.disc_fragment_5": "Piece o' shanty",
  "item.minecraft.disc_fragment_5.desc": "Shanty - 5",
  "item.minecraft.dolphin_spawn_egg": "Treasure hound cackle fruit",
  "item.minecraft.donkey_spawn_egg": "Furry cargo cackle fruit",
  "item.minecraft.dragon_breath": "Wyvern's breath",
  "item.minecraft.dried_kelp": "Dry sea lettuce",
  "item.minecraft.drowned_spawn_egg": "Sunken sailor cackle fruit",
  "item.minecraft.dune_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune cut o' armor",
  "item.minecraft.echo_shard": "Shard o' echoin'",
  "item.minecraft.egg": "Cackle fruit",
  "item.minecraft.elder_guardian_spawn_egg": "Great sea lurker cackle fruit",
  "item.minecraft.elytra": "Icarus' wings",
  "item.minecraft.emerald": "Emerald",
  "item.minecraft.enchanted_book": "Magic book",
  "item.minecraft.enchanted_golden_apple": "Witchcraft'd golden apple",
  "item.minecraft.end_crystal": "End crystal",
  "item.minecraft.ender_dragon_spawn_egg": "Ender wyvern cackle fruit",
  "item.minecraft.ender_eye": "Eye o' ender",
  "item.minecraft.ender_pearl": "Pearl o' ender",
  "item.minecraft.enderman_spawn_egg": "Enderman cackle fruit",
  "item.minecraft.endermite_spawn_egg": "Endermite cackle fruit",
  "item.minecraft.evoker_spawn_egg": "Summoner cackle fruit",
  "item.minecraft.experience_bottle": "Bottle o' wisdom",
  "item.minecraft.explorer_pottery_shard": "Navigator shard o' vase",
  "item.minecraft.explorer_pottery_sherd": "Navigator clay fragment",
  "item.minecraft.eye_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye cut o' armor",
  "item.minecraft.feather": "Feather",
  "item.minecraft.fermented_spider_eye": "Rotten eye o' night bug",
  "item.minecraft.field_masoned_banner_pattern": "Field masoned flag pattern",
  "item.minecraft.filled_map": "Treasure map",
  "item.minecraft.fire_charge": "Cannonball",
  "item.minecraft.firework_rocket": "Bomb o' spark'ls",
  "item.minecraft.firework_rocket.flight": "Flight duration:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Bomb o' stars",
  "item.minecraft.firework_star.black": "Black",
  "item.minecraft.firework_star.blue": "Blue",
  "item.minecraft.firework_star.brown": "Brown",
  "item.minecraft.firework_star.custom_color": "Yer own",
  "item.minecraft.firework_star.cyan": "Ocean blue",
  "item.minecraft.firework_star.fade_to": "Fade to",
  "item.minecraft.firework_star.flicker": "Twinkle",
  "item.minecraft.firework_star.gray": "Gray",
  "item.minecraft.firework_star.green": "Green",
  "item.minecraft.firework_star.light_blue": "Light blue",
  "item.minecraft.firework_star.light_gray": "Light gray",
  "item.minecraft.firework_star.lime": "Light green",
  "item.minecraft.firework_star.magenta": "Light purple",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Pink",
  "item.minecraft.firework_star.purple": "Purple",
  "item.minecraft.firework_star.red": "Scarlet",
  "item.minecraft.firework_star.shape": "Ghosty shape",
  "item.minecraft.firework_star.shape.burst": "Wrath",
  "item.minecraft.firework_star.shape.creeper": "Shape o' creeper",
  "item.minecraft.firework_star.shape.large_ball": "Large ball",
  "item.minecraft.firework_star.shape.small_ball": "Small ball",
  "item.minecraft.firework_star.shape.star": "Star-shaped",
  "item.minecraft.firework_star.trail": "Ship's wake",
  "item.minecraft.firework_star.white": "White",
  "item.minecraft.firework_star.yellow": "Yellow",
  "item.minecraft.fishing_rod": "Fishin' rod",
  "item.minecraft.flint": "Pointy rock",
  "item.minecraft.flint_and_steel": "Ship's bane",
  "item.minecraft.flow_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow cut o' armor",
  "item.minecraft.flow_banner_pattern": "Flag pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow flag pattern",
  "item.minecraft.flow_pottery_sherd": "Flow clay fragment",
  "item.minecraft.flower_banner_pattern": "Flag pattern",
  "item.minecraft.flower_banner_pattern.desc": "Flower charge",
  "item.minecraft.flower_banner_pattern.new": "Flower charge flag pattern",
  "item.minecraft.flower_pot": "Dirt vase",
  "item.minecraft.fox_spawn_egg": "Fox cackle fruit",
  "item.minecraft.friend_pottery_shard": "Matey's shard o' vase",
  "item.minecraft.friend_pottery_sherd": "Matey's clay fragment",
  "item.minecraft.frog_spawn_egg": "Frog cackle fruit",
  "item.minecraft.furnace_minecart": "Oven in a landlubbers' boat",
  "item.minecraft.ghast_spawn_egg": "Ghast cackle fruit",
  "item.minecraft.ghast_tear": "Tear o' ghast",
  "item.minecraft.glass_bottle": "Cup o' glass",
  "item.minecraft.glistering_melon_slice": "Shining slic'd melon",
  "item.minecraft.globe_banner_pattern": "Flag pattern",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "Globe flag pattern",
  "item.minecraft.glow_berries": "Glowin' capers",
  "item.minecraft.glow_ink_sac": "Kraken's glowin' paint",
  "item.minecraft.glow_item_frame": "Glowin' booty holder",
  "item.minecraft.glow_squid_spawn_egg": "Glowin' Kraken cackle fruit",
  "item.minecraft.glowstone_dust": "Glowstone powder",
  "item.minecraft.goat_horn": "Blowin' horn",
  "item.minecraft.goat_spawn_egg": "Goat cackle fruit",
  "item.minecraft.gold_ingot": "Bullion o' gold",
  "item.minecraft.gold_nugget": "Doubloon o' gold",
  "item.minecraft.golden_apple": "Eden's apple",
  "item.minecraft.golden_axe": "Hatchet o' gold",
  "item.minecraft.golden_boots": "Peg-leg o' gold",
  "item.minecraft.golden_carrot": "Orange veggie o' gold",
  "item.minecraft.golden_chestplate": "Chestplate o' gold",
  "item.minecraft.golden_helmet": "Helmet o' gold",
  "item.minecraft.golden_hoe": "Farmin' stick o' gold",
  "item.minecraft.golden_horse_armor": "Brumby armor o' gold",
  "item.minecraft.golden_leggings": "Greaves o' gold",
  "item.minecraft.golden_nautilus_armor": "Sea beast's clothin' o' gold",
  "item.minecraft.golden_pickaxe": "Pickaxe o' gold",
  "item.minecraft.golden_shovel": "Spade o' gold",
  "item.minecraft.golden_spear": "Harpoon o' gold",
  "item.minecraft.golden_sword": "Cutlass o' gold",
  "item.minecraft.gray_bundle": "Gray pouch",
  "item.minecraft.gray_dye": "Dye o' gray",
  "item.minecraft.gray_harness": "Gray harness",
  "item.minecraft.green_bundle": "Green pouch",
  "item.minecraft.green_dye": "Dye o' green",
  "item.minecraft.green_harness": "Green harness",
  "item.minecraft.guardian_spawn_egg": "Sea lurker cackle fruit",
  "item.minecraft.gunpowder": "Black powder",
  "item.minecraft.guster_banner_pattern": "Flag pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster flag pattern",
  "item.minecraft.guster_pottery_sherd": "Guster clay fragment",
  "item.minecraft.happy_ghast_spawn_egg": "Ghast o' glee cackle fruit",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Heart o' Davy Jones",
  "item.minecraft.heart_pottery_shard": "Lovey shard o' vase",
  "item.minecraft.heart_pottery_sherd": "Lovey clay fragment",
  "item.minecraft.heartbreak_pottery_shard": "'Eartbreak shard o' vase",
  "item.minecraft.heartbreak_pottery_sherd": "'Eartbreak clay fragment",
  "item.minecraft.hoglin_spawn_egg": "Hoglin cackle fruit",
  "item.minecraft.honey_bottle": "Bottle o' bee nectar",
  "item.minecraft.honeycomb": "Treasure o' bee",
  "item.minecraft.hopper_minecart": "Suckin' device in a landlubbers' boat",
  "item.minecraft.horse_spawn_egg": "Brumby cackle fruit",
  "item.minecraft.host_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host cut o' armor",
  "item.minecraft.howl_pottery_shard": "Wailin' shard o' vase",
  "item.minecraft.howl_pottery_sherd": "Wailin' clay fragment",
  "item.minecraft.husk_spawn_egg": "Heated sailor cackle fruit",
  "item.minecraft.ink_sac": "Kraken's paint",
  "item.minecraft.iron_axe": "Hatchet o' steel",
  "item.minecraft.iron_boots": "Peg-leg o' steel",
  "item.minecraft.iron_chestplate": "Chestplate o' steel",
  "item.minecraft.iron_golem_spawn_egg": "Golem o' steel cackle fruit",
  "item.minecraft.iron_helmet": "Helmet o' steel",
  "item.minecraft.iron_hoe": "Farmin' stick o' steel",
  "item.minecraft.iron_horse_armor": "Brumby armor o' steel",
  "item.minecraft.iron_ingot": "Bullion o' steel",
  "item.minecraft.iron_leggings": "Greaves o' steel",
  "item.minecraft.iron_nautilus_armor": "Sea beast's clothin' o' steel",
  "item.minecraft.iron_nugget": "Doubloon o' steel",
  "item.minecraft.iron_pickaxe": "Pickaxe o' steel",
  "item.minecraft.iron_shovel": "Spade o' steel",
  "item.minecraft.iron_spear": "Harpoon o' steel",
  "item.minecraft.iron_sword": "Cutlass o' steel",
  "item.minecraft.item_frame": "Booty holder",
  "item.minecraft.jungle_boat": "Vessel o' jungle",
  "item.minecraft.jungle_chest_boat": "Vessel o' jungle wit' coffer",
  "item.minecraft.knowledge_book": "Tome o' intellect",
  "item.minecraft.lapis_lazuli": "Lāzhward",
  "item.minecraft.lava_bucket": "Pail o' molten rock",
  "item.minecraft.lead": "Rope",
  "item.minecraft.leather": "Leather",
  "item.minecraft.leather_boots": "Peg-leg o' leather",
  "item.minecraft.leather_chestplate": "Jacket o' leather",
  "item.minecraft.leather_helmet": "Bandana o' leather",
  "item.minecraft.leather_horse_armor": "Brumby armor o' leather",
  "item.minecraft.leather_leggings": "Breeches o' leather",
  "item.minecraft.light_blue_bundle": "Light blue pouch",
  "item.minecraft.light_blue_dye": "Dye o' light blue",
  "item.minecraft.light_blue_harness": "Light blue harness",
  "item.minecraft.light_gray_bundle": "Light gray pouch",
  "item.minecraft.light_gray_dye": "Dye o' light gray",
  "item.minecraft.light_gray_harness": "Light gray harness",
  "item.minecraft.lime_bundle": "Light green pouch",
  "item.minecraft.lime_dye": "Dye o' light green",
  "item.minecraft.lime_harness": "Light green harness",
  "item.minecraft.lingering_potion": "Bottled fog",
  "item.minecraft.lingering_potion.effect.awkward": "Odd bottled fog",
  "item.minecraft.lingering_potion.effect.empty": "Uncraftable bottled fog",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Bottled fog o' flame's bane",
  "item.minecraft.lingering_potion.effect.harming": "Bottled fog o' keelhaulin'",
  "item.minecraft.lingering_potion.effect.healing": "Bottled fog o' healin'",
  "item.minecraft.lingering_potion.effect.infested": "Bottled fog o' inhabitation",
  "item.minecraft.lingering_potion.effect.invisibility": "Bottled fog o' invisibility",
  "item.minecraft.lingering_potion.effect.leaping": "Bottled fog o' leapin'",
  "item.minecraft.lingering_potion.effect.levitation": "Bottled fog o' flyin'",
  "item.minecraft.lingering_potion.effect.luck": "Bottled fog o' luck",
  "item.minecraft.lingering_potion.effect.mundane": "Useless bottled fog",
  "item.minecraft.lingering_potion.effect.night_vision": "Bottled fog o' moonlight",
  "item.minecraft.lingering_potion.effect.oozing": "Bottled fog o' oozin'",
  "item.minecraft.lingering_potion.effect.poison": "Bottled fog o' toxin",
  "item.minecraft.lingering_potion.effect.regeneration": "Bottled fog o' feelin' better slowly",
  "item.minecraft.lingering_potion.effect.slow_falling": "Bottled fog o' Mary Poppins' syndrome",
  "item.minecraft.lingering_potion.effect.slowness": "Bottled fog o' sloth",
  "item.minecraft.lingering_potion.effect.strength": "Bottled fog o' hardiness",
  "item.minecraft.lingering_potion.effect.swiftness": "Bottled fog o' full sails",
  "item.minecraft.lingering_potion.effect.thick": "Soupy bottled fog",
  "item.minecraft.lingering_potion.effect.turtle_master": "Bottled fog o' turtle master",
  "item.minecraft.lingering_potion.effect.water": "Bottled fog",
  "item.minecraft.lingering_potion.effect.water_breathing": "Bottled fog o' mermaid's blessin'",
  "item.minecraft.lingering_potion.effect.weakness": "Bottled fog o' laziness",
  "item.minecraft.lingering_potion.effect.weaving": "Bottled fog o' night bug's bane",
  "item.minecraft.lingering_potion.effect.wind_charged": "Bottled fog o' blasted wind",
  "item.minecraft.llama_spawn_egg": "Spittin' sheep cackle fruit",
  "item.minecraft.lodestone_compass": "Sextant o' wayfindin' rock",
  "item.minecraft.mace": "Bone crusher",
  "item.minecraft.magenta_bundle": "Light purple pouch",
  "item.minecraft.magenta_dye": "Dye o' light purple",
  "item.minecraft.magenta_harness": "Light purple harness",
  "item.minecraft.magma_cream": "Flamin' cream",
  "item.minecraft.magma_cube_spawn_egg": "Cube o' magma cackle fruit",
  "item.minecraft.mangrove_boat": "Vessel o' mangrove",
  "item.minecraft.mangrove_chest_boat": "Vessel o' mangrove wit' coffer",
  "item.minecraft.map": "Em'ty treasure map",
  "item.minecraft.melon_seeds": "Seeds o' melon",
  "item.minecraft.melon_slice": "Slic'd melon",
  "item.minecraft.milk_bucket": "Pail o' bovine's juice",
  "item.minecraft.minecart": "Landlubbers' boat",
  "item.minecraft.miner_pottery_shard": "Treasure digger shard o' vase",
  "item.minecraft.miner_pottery_sherd": "Treasure digger clay fragment",
  "item.minecraft.mojang_banner_pattern": "Flag pattern",
  "item.minecraft.mojang_banner_pattern.desc": "Thing",
  "item.minecraft.mojang_banner_pattern.new": "Thing flag pattern",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom cackle fruit",
  "item.minecraft.mourner_pottery_shard": "Grievin' shard o' vase",
  "item.minecraft.mourner_pottery_sherd": "Grievin' clay fragment",
  "item.minecraft.mule_spawn_egg": "Mule cackle fruit",
  "item.minecraft.mushroom_stew": "Shroom goulash",
  "item.minecraft.music_disc_11": "Shanty",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Shanty",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Shanty",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Shanty",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Shanty",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Shanty",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Shanty",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Shanty",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Shanty box)",
  "item.minecraft.music_disc_far": "Shanty",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Shanty",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Shanty",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Shanty",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Shanty",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Shanty",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Shanty",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Shanty",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Shanty",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Shanty",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Shanty",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Shanty",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Shanty",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Raw meat o' sheep",
  "item.minecraft.name_tag": "Name yer mate",
  "item.minecraft.nautilus_shell": "Sea beast's shell",
  "item.minecraft.nautilus_spawn_egg": "Sea beast cackle fruit",
  "item.minecraft.nether_brick": "Brick o' Nether",
  "item.minecraft.nether_star": "Star o' Nether",
  "item.minecraft.nether_wart": "Verruca o' Nether",
  "item.minecraft.netherite_axe": "Blackbeard's battleaxe",
  "item.minecraft.netherite_boots": "Blackbeard's waders",
  "item.minecraft.netherite_chestplate": "Blackbeard's doublet",
  "item.minecraft.netherite_helmet": "Blackbeard's tricorn hat",
  "item.minecraft.netherite_hoe": "Blackbeard's scythe",
  "item.minecraft.netherite_horse_armor": "Blackbeard's brumby armor",
  "item.minecraft.netherite_ingot": "Bullion o' Blackbeard's alloy",
  "item.minecraft.netherite_leggings": "Blackbeard's breeches",
  "item.minecraft.netherite_nautilus_armor": "Blackbeard's clothin' fer th' sea beast",
  "item.minecraft.netherite_pickaxe": "Blackbeard's pickaxe",
  "item.minecraft.netherite_scrap": "Blackbeard's scrap",
  "item.minecraft.netherite_shovel": "Blackbeard's spade",
  "item.minecraft.netherite_spear": "Blackbeard's harpoon",
  "item.minecraft.netherite_sword": "Blackbeard's claymore",
  "item.minecraft.netherite_upgrade_smithing_template": "Template o' smithing",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Captain's upgrade",
  "item.minecraft.oak_boat": "Oak'n vessel",
  "item.minecraft.oak_chest_boat": "Vessel o' oak wit' coffer",
  "item.minecraft.ocelot_spawn_egg": "Lynx cackle fruit",
  "item.minecraft.ominous_bottle": "Foul bottle",
  "item.minecraft.ominous_trial_key": "Key o' foul trials",
  "item.minecraft.orange_bundle": "Orange pouch",
  "item.minecraft.orange_dye": "Dye o' orange",
  "item.minecraft.orange_harness": "Orange harness",
  "item.minecraft.painting": "Portrait",
  "item.minecraft.pale_oak_boat": "Vessel o' wash'd out oak",
  "item.minecraft.pale_oak_chest_boat": "Vessel o' wash'd out oak wit' coffer",
  "item.minecraft.panda_spawn_egg": "Landlubbin' orca cackle fruit",
  "item.minecraft.paper": "Parchment",
  "item.minecraft.parched_spawn_egg": "Dried bag o' bones cackle fruit",
  "item.minecraft.parrot_spawn_egg": "Best matey cackle fruit",
  "item.minecraft.phantom_membrane": "Membrane o' th' flyin' devil",
  "item.minecraft.phantom_spawn_egg": "Flyin' devil cackle fruit",
  "item.minecraft.pig_spawn_egg": "Swine cackle fruit",
  "item.minecraft.piglin_banner_pattern": "Flag pattern",
  "item.minecraft.piglin_banner_pattern.desc": "Snout",
  "item.minecraft.piglin_banner_pattern.new": "Snout flag pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin squire cackle fruit",
  "item.minecraft.piglin_spawn_egg": "Piglin cackle fruit",
  "item.minecraft.pillager_spawn_egg": "Raider cackle fruit",
  "item.minecraft.pink_bundle": "Pink pouch",
  "item.minecraft.pink_dye": "Dye o' pink",
  "item.minecraft.pink_harness": "Pink harness",
  "item.minecraft.pitcher_plant": "Barrrel plant",
  "item.minecraft.pitcher_pod": "Seed o' barrrel plant",
  "item.minecraft.plenty_pottery_shard": "Bountiful shard o' vase",
  "item.minecraft.plenty_pottery_sherd": "Bountiful clay fragment",
  "item.minecraft.poisonous_potato": "Toxic tater",
  "item.minecraft.polar_bear_spawn_egg": "Snowy beast cackle fruit",
  "item.minecraft.popped_chorus_fruit": "Baked tall one's fruit",
  "item.minecraft.porkchop": "Raw pigmeat",
  "item.minecraft.potato": "Tater",
  "item.minecraft.potion": "Brew",
  "item.minecraft.potion.effect.awkward": "Odd brew",
  "item.minecraft.potion.effect.empty": "Uncraftable brew",
  "item.minecraft.potion.effect.fire_resistance": "Brew o' flame's bane",
  "item.minecraft.potion.effect.harming": "Brew o' keelhaulin'",
  "item.minecraft.potion.effect.healing": "Brew o' healin'",
  "item.minecraft.potion.effect.infested": "Brew o' inhabitation",
  "item.minecraft.potion.effect.invisibility": "Brew o' invisibility",
  "item.minecraft.potion.effect.leaping": "Brew o' leapin'",
  "item.minecraft.potion.effect.levitation": "Brew o' flyin'",
  "item.minecraft.potion.effect.luck": "Brew o' luck",
  "item.minecraft.potion.effect.mundane": "Useless brew",
  "item.minecraft.potion.effect.night_vision": "Brew o' moonlight",
  "item.minecraft.potion.effect.oozing": "Brew o' oozin'",
  "item.minecraft.potion.effect.poison": "Brew o' toxin",
  "item.minecraft.potion.effect.regeneration": "Brew o' feelin' better slowly",
  "item.minecraft.potion.effect.slow_falling": "Brew o' Mary Poppins' syndrome",
  "item.minecraft.potion.effect.slowness": "Brew o' sloth",
  "item.minecraft.potion.effect.strength": "Brew o' hardiness",
  "item.minecraft.potion.effect.swiftness": "Brew o' full sails",
  "item.minecraft.potion.effect.thick": "Soupy brew",
  "item.minecraft.potion.effect.turtle_master": "Brew o' turtle master",
  "item.minecraft.potion.effect.water": "Bottle o' bilge",
  "item.minecraft.potion.effect.water_breathing": "Brew o' mermaid's blessin'",
  "item.minecraft.potion.effect.weakness": "Brew o' laziness",
  "item.minecraft.potion.effect.weaving": "Brew o' night bug's bane",
  "item.minecraft.potion.effect.wind_charged": "Brew o' blasted wind",
  "item.minecraft.pottery_shard_archer": "Bowman's shard o' vase",
  "item.minecraft.pottery_shard_arms_up": "Arms to th' sky shard o' vase",
  "item.minecraft.pottery_shard_prize": "Treasure shard o' vase",
  "item.minecraft.pottery_shard_skull": "Skull shard o' vase",
  "item.minecraft.powder_snow_bucket": "Pail o' snowier snow",
  "item.minecraft.prismarine_crystals": "Crystals o' prismarine",
  "item.minecraft.prismarine_shard": "Shard o' prismarine",
  "item.minecraft.prize_pottery_shard": "Treasure shard o' vase",
  "item.minecraft.prize_pottery_sherd": "Treasure clay fragment",
  "item.minecraft.pufferfish": "Blowfish",
  "item.minecraft.pufferfish_bucket": "Pail o' blowfish",
  "item.minecraft.pufferfish_spawn_egg": "Blowfish cackle fruit",
  "item.minecraft.pumpkin_pie": "Roasted gourd",
  "item.minecraft.pumpkin_seeds": "Seeds o' gourd squash",
  "item.minecraft.purple_bundle": "Purple pouch",
  "item.minecraft.purple_dye": "Dye o' purple",
  "item.minecraft.purple_harness": "Purple harness",
  "item.minecraft.quartz": "White rock",
  "item.minecraft.rabbit": "Raw rabbit",
  "item.minecraft.rabbit_foot": "Foot o' rabbit",
  "item.minecraft.rabbit_hide": "Hide o' rabbit",
  "item.minecraft.rabbit_spawn_egg": "Rabbit cackle fruit",
  "item.minecraft.rabbit_stew": "Stew o' rabbit",
  "item.minecraft.raiser_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser cut o' armor",
  "item.minecraft.ravager_spawn_egg": "Arrvager cackle fruit",
  "item.minecraft.raw_copper": "Rough copper",
  "item.minecraft.raw_gold": "Rough gold",
  "item.minecraft.raw_iron": "Rough steel",
  "item.minecraft.recovery_compass": "Sextant o' relootin'",
  "item.minecraft.red_bundle": "Scarlet pouch",
  "item.minecraft.red_dye": "Dye o' scarlet",
  "item.minecraft.red_harness": "Scarlet harness",
  "item.minecraft.redstone": "Redstone powder",
  "item.minecraft.resin_brick": "Brick o' treacle ooze",
  "item.minecraft.resin_clump": "Pile o' treacle ooze",
  "item.minecraft.rib_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib cut o' armor",
  "item.minecraft.rotten_flesh": "Putrid rations",
  "item.minecraft.saddle": "Saddle",
  "item.minecraft.salmon": "Raw salmon",
  "item.minecraft.salmon_bucket": "Pail o' salmon",
  "item.minecraft.salmon_spawn_egg": "Salmon cackle fruit",
  "item.minecraft.scrape_pottery_sherd": "Scrape clay fragment",
  "item.minecraft.scute": "Piece o' turtleshell",
  "item.minecraft.sentry_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry cut o' armor",
  "item.minecraft.shaper_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper cut o' armor",
  "item.minecraft.sheaf_pottery_shard": "Bundle o' wheat shard o' vase",
  "item.minecraft.sheaf_pottery_sherd": "Bundle o' wheat clay fragment",
  "item.minecraft.shears": "Cutters",
  "item.minecraft.sheep_spawn_egg": "Sheep cackle fruit",
  "item.minecraft.shelter_pottery_shard": "Haven shard o' vase",
  "item.minecraft.shelter_pottery_sherd": "Haven clay fragment",
  "item.minecraft.shield": "Targe",
  "item.minecraft.shield.black": "Black targe",
  "item.minecraft.shield.blue": "Blue targe",
  "item.minecraft.shield.brown": "Brown targe",
  "item.minecraft.shield.cyan": "Ocean blue targe",
  "item.minecraft.shield.gray": "Gray targe",
  "item.minecraft.shield.green": "Green targe",
  "item.minecraft.shield.light_blue": "Light blue targe",
  "item.minecraft.shield.light_gray": "Light gray targe",
  "item.minecraft.shield.lime": "Light green targe",
  "item.minecraft.shield.magenta": "Light purple targe",
  "item.minecraft.shield.orange": "Orange targe",
  "item.minecraft.shield.pink": "Pink targe",
  "item.minecraft.shield.purple": "Purple targe",
  "item.minecraft.shield.red": "Scarlet targe",
  "item.minecraft.shield.white": "White targe",
  "item.minecraft.shield.yellow": "Yellow targe",
  "item.minecraft.shulker_shell": "Shulker shell",
  "item.minecraft.shulker_spawn_egg": "Shulker cackle fruit",
  "item.minecraft.sign": "Seal",
  "item.minecraft.silence_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence cut o' armor",
  "item.minecraft.silverfish_spawn_egg": "Bilge rat cackle fruit",
  "item.minecraft.skeleton_horse_spawn_egg": "Bag o' bones' brumby cackle fruit",
  "item.minecraft.skeleton_spawn_egg": "Bag o' bones cackle fruit",
  "item.minecraft.skull_banner_pattern": "Flag pattern",
  "item.minecraft.skull_banner_pattern.desc": "Skull charge",
  "item.minecraft.skull_banner_pattern.new": "Skull charge flag pattern",
  "item.minecraft.skull_pottery_shard": "Skull shard o' vase",
  "item.minecraft.skull_pottery_sherd": "Skull clay fragment",
  "item.minecraft.slime_ball": "Ball o' slime",
  "item.minecraft.slime_spawn_egg": "Cube o' slime cackle fruit",
  "item.minecraft.smithing_template": "Template o' smithing",
  "item.minecraft.smithing_template.applies_to": "Rules over:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Add bullion o' gem",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Protectin'",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Add yer piece o' armor",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Bullion & gems",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Add bullion o' Blackbeard's alloy",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond gear",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add armor o' diamond, cutlass, o' tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Bullion o' Blackbeard's alloy",
  "item.minecraft.smithing_template.upgrade": "Make better: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffin' beast cackle fruit",
  "item.minecraft.snort_pottery_shard": "Snort shard o' vase",
  "item.minecraft.snort_pottery_sherd": "Snort clay fragment",
  "item.minecraft.snout_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout cut o' armor",
  "item.minecraft.snow_golem_spawn_egg": "Golem o' snow cackle fruit",
  "item.minecraft.snowball": "Ball o' snow",
  "item.minecraft.spectral_arrow": "Magic bolt",
  "item.minecraft.spider_eye": "Night bug eyeball",
  "item.minecraft.spider_spawn_egg": "Night bug cackle fruit",
  "item.minecraft.spire_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Towerin' cut o' armor",
  "item.minecraft.splash_potion": "Grenade",
  "item.minecraft.splash_potion.effect.awkward": "Odd grenade",
  "item.minecraft.splash_potion.effect.empty": "Uncraftable grenade",
  "item.minecraft.splash_potion.effect.fire_resistance": "Grenade o' flame's bane",
  "item.minecraft.splash_potion.effect.harming": "Grenade o' keelhaulin'",
  "item.minecraft.splash_potion.effect.healing": "Grenade o' healin'",
  "item.minecraft.splash_potion.effect.infested": "Grenade o' inhabitation",
  "item.minecraft.splash_potion.effect.invisibility": "Grenade o' invisibility",
  "item.minecraft.splash_potion.effect.leaping": "Grenade o' leapin'",
  "item.minecraft.splash_potion.effect.levitation": "Grenade o' flyin'",
  "item.minecraft.splash_potion.effect.luck": "Grenade o' luck",
  "item.minecraft.splash_potion.effect.mundane": "Useless grenade",
  "item.minecraft.splash_potion.effect.night_vision": "Grenade o' moonlight",
  "item.minecraft.splash_potion.effect.oozing": "Grenade o' oozin'",
  "item.minecraft.splash_potion.effect.poison": "Grenade o' toxin",
  "item.minecraft.splash_potion.effect.regeneration": "Grenade o' feelin' better slowly",
  "item.minecraft.splash_potion.effect.slow_falling": "Grenade o' Mary Poppins' syndrome",
  "item.minecraft.splash_potion.effect.slowness": "Grenade o' sloth",
  "item.minecraft.splash_potion.effect.strength": "Grenade o' hardiness",
  "item.minecraft.splash_potion.effect.swiftness": "Grenade o' full sails",
  "item.minecraft.splash_potion.effect.thick": "Soupy grenade",
  "item.minecraft.splash_potion.effect.turtle_master": "Grenade o' turtle master",
  "item.minecraft.splash_potion.effect.water": "Grenade o' bilge",
  "item.minecraft.splash_potion.effect.water_breathing": "Grenade o' mermaid's blessin'",
  "item.minecraft.splash_potion.effect.weakness": "Grenade o' laziness",
  "item.minecraft.splash_potion.effect.weaving": "Grenade o' night bug's bane",
  "item.minecraft.splash_potion.effect.wind_charged": "Grenade o' blasted wind",
  "item.minecraft.spruce_boat": "Vessel o' spruce",
  "item.minecraft.spruce_chest_boat": "Vessel o' spruce wit' coffer",
  "item.minecraft.spyglass": "Bring 'em near",
  "item.minecraft.squid_spawn_egg": "Kraken cackle fruit",
  "item.minecraft.stick": "Piece o' timber",
  "item.minecraft.stone_axe": "Hatchet o' rock",
  "item.minecraft.stone_hoe": "Farmin' stick o' rock",
  "item.minecraft.stone_pickaxe": "Pickaxe o' rock",
  "item.minecraft.stone_shovel": "Spade o' rock",
  "item.minecraft.stone_spear": "Harpoon o' rock",
  "item.minecraft.stone_sword": "Cutlass o' rock",
  "item.minecraft.stray_spawn_egg": "Wanderin' bag o' bones cackle fruit",
  "item.minecraft.strider_spawn_egg": "Fish o' th' underworld cackle fruit",
  "item.minecraft.string": "Cheap rope",
  "item.minecraft.sugar": "Sugarrr",
  "item.minecraft.suspicious_stew": "Fishy gruel",
  "item.minecraft.sweet_berries": "Land capers",
  "item.minecraft.tadpole_bucket": "Pail o' polliwog",
  "item.minecraft.tadpole_spawn_egg": "Polliwog cackle fruit",
  "item.minecraft.tide_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide cut o' armor",
  "item.minecraft.tipped_arrow": "Tipped bolt",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped bolt",
  "item.minecraft.tipped_arrow.effect.empty": "Uncraftable tipped bolt",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Bolt o' flame's bane",
  "item.minecraft.tipped_arrow.effect.harming": "Bolt o' keelhaulin'",
  "item.minecraft.tipped_arrow.effect.healing": "Bolt o' healin'",
  "item.minecraft.tipped_arrow.effect.infested": "Bolt o' inhabitation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Bolt o' invisibility",
  "item.minecraft.tipped_arrow.effect.leaping": "Bolt o' leapin'",
  "item.minecraft.tipped_arrow.effect.levitation": "Bolt o' flyin'",
  "item.minecraft.tipped_arrow.effect.luck": "Bolt o' luck",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped bolt",
  "item.minecraft.tipped_arrow.effect.night_vision": "Bolt o' moonlight",
  "item.minecraft.tipped_arrow.effect.oozing": "Bolt o' oozin'",
  "item.minecraft.tipped_arrow.effect.poison": "Bolt o' toxin",
  "item.minecraft.tipped_arrow.effect.regeneration": "Bolt o' feelin' better slowly",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Bolt o' Mary Poppins' syndrome",
  "item.minecraft.tipped_arrow.effect.slowness": "Bolt o' sloth",
  "item.minecraft.tipped_arrow.effect.strength": "Bolt o' hardiness",
  "item.minecraft.tipped_arrow.effect.swiftness": "Bolt o' full sails",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped bolt",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Bolt o' turtle master",
  "item.minecraft.tipped_arrow.effect.water": "Bolt o' splashin'",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Bolt o' mermaid's blessin'",
  "item.minecraft.tipped_arrow.effect.weakness": "Bolt o' laziness",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow o' night bug's bane",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow o' blasted wind",
  "item.minecraft.tnt_minecart": "Powder keg in a landlubbers' boat",
  "item.minecraft.torchflower_seeds": "Seeds o' torchflower",
  "item.minecraft.totem_of_undying": "Jewel o' life",
  "item.minecraft.trader_llama_spawn_egg": "Nomad's spittin' sheep cackle fruit",
  "item.minecraft.trial_key": "Key o' trials",
  "item.minecraft.trident": "Poseidon's fightin' fork",
  "item.minecraft.tropical_fish": "Colorful fish",
  "item.minecraft.tropical_fish_bucket": "Pail o' colorful fish",
  "item.minecraft.tropical_fish_spawn_egg": "Colorful fish cackle fruit",
  "item.minecraft.turtle_helmet": "Shell o' turtle",
  "item.minecraft.turtle_scute": "Piece o' turtleshell",
  "item.minecraft.turtle_spawn_egg": "Turtle cackle fruit",
  "item.minecraft.vex_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex cut o' armor",
  "item.minecraft.vex_spawn_egg": "Nagger cackle fruit",
  "item.minecraft.villager_spawn_egg": "Landlubber cackle fruit",
  "item.minecraft.vindicator_spawn_egg": "Servant cackle fruit",
  "item.minecraft.wandering_trader_spawn_egg": "Nomad cackle fruit",
  "item.minecraft.ward_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Guard cut o' armor",
  "item.minecraft.warden_spawn_egg": "Monstrous beast cackle fruit",
  "item.minecraft.warped_fungus_on_a_stick": "Twisted fungus o' a stick",
  "item.minecraft.water_bucket": "Pail o' bilge",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Template o' smithing",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Navigator cut o' armor",
  "item.minecraft.wheat": "Hops",
  "item.minecraft.wheat_seeds": "Seeds o' hops",
  "item.minecraft.white_bundle": "White pouch",
  "item.minecraft.white_dye": "Dye o' white",
  "item.minecraft.white_harness": "White harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Template o' forgin'",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild cut o' armor",
  "item.minecraft.wind_charge": "Blast o' wind",
  "item.minecraft.witch_spawn_egg": "Wizard cackle fruit",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither bag o' bones cackle fruit",
  "item.minecraft.wither_spawn_egg": "Wither cackle fruit",
  "item.minecraft.wolf_armor": "Hound's clothin'",
  "item.minecraft.wolf_spawn_egg": "Hound cackle fruit",
  "item.minecraft.wooden_axe": "Hatchet o' timber",
  "item.minecraft.wooden_hoe": "Farmin' stick o' timber",
  "item.minecraft.wooden_pickaxe": "Pickaxe o' timber",
  "item.minecraft.wooden_shovel": "Spade o' timber",
  "item.minecraft.wooden_spear": "Harpoon o' timber",
  "item.minecraft.wooden_sword": "Cutlass o' timber",
  "item.minecraft.writable_book": "Captain's log",
  "item.minecraft.written_book": "Full logbook",
  "item.minecraft.yellow_bundle": "Yellow pouch",
  "item.minecraft.yellow_dye": "Dye o' yellow",
  "item.minecraft.yellow_harness": "Yellow harness",
  "item.minecraft.zoglin_spawn_egg": "Zoglin cackle fruit",
  "item.minecraft.zombie_horse_spawn_egg": "Undead brumby cackle fruit",
  "item.minecraft.zombie_nautilus_spawn_egg": "Undead sea beast cackle fruit",
  "item.minecraft.zombie_spawn_egg": "Undead sailor cackle fruit",
  "item.minecraft.zombie_villager_spawn_egg": "Undead landlubber cackle fruit",
  "item.minecraft.zombified_piglin_spawn_egg": "Undead piglin cackle fruit"
}
export const en_pt = items; 
